// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-05T17:25:37.848Z
// Property: Reno Vista Apartments (ID: 6767906449166657)
// Collections: 35 amenities, 7 floorplans (live), 13 photos, 37 POIs, 1 reviews, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5742705921490944",
  "multihub_property_id": "6767906449166657",
  "property_external_id": "ldjcfdf",
  "property_zillow_url": "https://www.zillow.com/apartments/reno-nv/reno-vista-apartments/5XjPy9/",
  "property_apartments_url": "https://www.apartments.com/reno-vista-reno-nv/ldjcfdf/",
  "property_google_business_url": "https://www.google.com/maps/place/Reno+Vista/data=!4m2!3m1!1s0x0:0xbfa6887580aa8619?sa=X&ved=2ahUKEwihxuv85aeSAxV3oK8BHeG8ApAQ_BJ6BAhDEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "42190899218",
  "property_crm_software": "Anyone Home",
  "property_pm_software": "AIM",
  "property_pm_info": "22RNO",
  "property_status": null,
  "property_slug": "reno-vista-apartments",
  "property_name": "Reno Vista Apartments",
  "property_website_url": "https://www.renovistaapts.com/",
  "property_domain": "https://www.renovistaapts.com/",
  "property_address": "3277 Reno Vista Drive",
  "property_full_address": "3277 Reno Vista Dr, Reno, NV 89512",
  "property_address_1": "3277 Reno Vista Dr",
  "property_address_2": null,
  "property_address_city": "Reno",
  "property_address_state": "NV",
  "property_address_zip_full": null,
  "property_address_zip": "89512",
  "property_address_country": "US",
  "property_address_county": "Washoe County",
  "property_neighborhood_address": "Northeast Reno",
  "property_address_latitude": "39.5647627",
  "property_address_longitude": "-119.7921812",
  "property_email": null,
  "property_phone": "(775) 414-9331",
  "property_call_tracking_phone": "8554814585",
  "property_company_name": "Apartment Management Consultants",
  "property_company_url": "https://www.liveamc.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "<p><strong>See Reno from a higher point of view.</strong> Reno Vista pairs one- and two-bedroom homes with select city-light, Sierra sunset, and mountain views—plus simple everyday comfort in the north hills. Explore <a href=\"/floor-plans\">floor plans</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> today.</p>",
  "property_long_description": "<p><strong>See Reno from a higher point of view.</strong> At Reno Vista Apartments, you’re tucked into the north hills of Northeast Reno, where select homes frame city lights, Sierra sunsets, and wide-open mountain views. Choose from one- and two-bedroom <a href=\"/floor-plans\">floor plans</a> with everyday comforts like air conditioning, dishwashers, ceiling fans, cable/internet readiness, private patios or balconies, and in-home washer/dryer features.</p><p>Life here is designed to stay simple: professional management, 24-hour emergency maintenance, surface and guest parking, a pet exercise park, playground, picnic areas, and quick access to public transportation and US 395. When you’re ready to get out, you’re close to UNR, TMCC, Wildcreek Golf Course, Rancho San Rafael Regional Park, Downtown Reno, Sparks, and the evolving Oddie District for local dining and shopping. Explore more <a href=\"/amenities\">community amenities</a>, then see why Reno Vista puts comfort, views, and city convenience within easy reach.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166657/019d02ce-ea0a-73ba-9490-cac00b67ae6a.webp",
  "property_featured_image_media": {
    "alt_text": "Picnic table and barbecue grill in a grassy park area with trees and a chain-link fence.",
    "public_id": "019d02ce-ea0a-73ba-9490-cac00b67ae6a",
    "storage_key": "property/6767906449166657/019d02ce-ea0a-73ba-9490-cac00b67ae6a.webp",
    "width": 800,
    "height": 600
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "275",
  "property_year_built": "1986",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "97.81818181818181",
  "property_admin_fee": null,
  "property_application_fee": "65",
  "property_fees_deposit_info": "Security Deposit\n$350",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "400",
  "property_pet_deposit": "200",
  "property_monthly_pet_rent": "35",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "We allow up to 2 pets per apartment (cats and dogs). Breed restrictions apply.",
  "property_pet_policy_description": "We allow up to 2 pets per apartment (cats and dogs). Pet rent is $35 per pet per month. Pet deposit is $400 per pet (non‑refundable). Breed restrictions apply.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": null,
  "property_resident_portal_url": "https://www.amcrentpay.com/Account/Login.aspx",
  "property_apply_now_url": "https://myrentalapplication.com/index/amcrenovista",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166657/019d02ce-d831-75cd-ad6c-a2f7fe842514.webp",
  "property_primary_logo_media": {
    "alt_text": "Reno Vista Apartments logo",
    "public_id": "019d02ce-d831-75cd-ad6c-a2f7fe842514",
    "storage_key": "property/6767906449166657/019d02ce-d831-75cd-ad6c-a2f7fe842514.webp",
    "width": 285,
    "height": 123
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166657/019f47ff-fc47-740e-b93c-0a28221aa035.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Black screen",
    "public_id": "019f47ff-fc47-740e-b93c-0a28221aa035",
    "storage_key": "property/6767906449166657/019f47ff-fc47-740e-b93c-0a28221aa035.webp",
    "width": 285,
    "height": 123
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166657/019f47ff-f15d-762f-9679-3fe458435426.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Black square image",
    "public_id": "019f47ff-f15d-762f-9679-3fe458435426",
    "storage_key": "property/6767906449166657/019f47ff-f15d-762f-9679-3fe458435426.webp",
    "width": 285,
    "height": 123
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019d02c4-5da7-768a-9221-bb30f19666be.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019d02c4-532b-737e-bc65-d92182ca8ca4.webp",
  "property_company_logo_media": {
    "alt_text": "Apartment Management Consultants logo",
    "public_id": "019d02c4-532b-737e-bc65-d92182ca8ca4",
    "storage_key": "company/5742705921490944/019d02c4-532b-737e-bc65-d92182ca8ca4.webp",
    "width": 640,
    "height": 309
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019f6696-c195-7642-9eb0-0a4d0423bad7.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "Logo for Apartment Management Consultants with a house icon.",
    "public_id": "019f6696-c195-7642-9eb0-0a4d0423bad7",
    "storage_key": "company/5742705921490944/019f6696-c195-7642-9eb0-0a4d0423bad7.webp",
    "width": 320,
    "height": 154
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019f6696-f877-771a-b04d-e0c2089d85b0.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "Apartment Management Consultants logo",
    "public_id": "019f6696-f877-771a-b04d-e0c2089d85b0",
    "storage_key": "company/5742705921490944/019f6696-f877-771a-b04d-e0c2089d85b0.webp",
    "width": 320,
    "height": 154
  },
  "property_primary_color": "#38505a",
  "property_secondary_color": "#9b7a68",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 2",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 1.5",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "1.5",
  "property_sqft_range": "850 - 850",
  "property_sqft_min": "850",
  "property_sqft_max": "850",
  "property_price_range": null,
  "property_price_min": null,
  "property_price_max": null,
  "property_available_units": 6,
  "property_facebook_url": "https://www.facebook.com/RenoVistaApts",
  "property_instagram_url": "https://www.instagram.com/renovistaapartmentsnv/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJQ0V3rn1HmYARGYaqgHWIpr8",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/search?find_desc=Cheap+Apartments&find_loc=Reno%2C+NV",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Reno Vista Apartments",
  "property_home_romance_title": "Welcome to Reno Vista Apartments",
  "property_home_amenities_blurb": "Welcome to Reno Vista Apartments, where modern living meets comfort in the heart of Reno, NV. Our spacious one and two-bedroom floor plans boast stylish features like granite countertops and stainless steel appliances. Enjoy vibrant community amenities from a pet-friendly playground to scenic walking trails, all designed for your convenience and enjoyment.",
  "property_home_floorplans_blurb": "At Reno Vista Apartments in scenic Reno, NV, you'll find beautifully designed one and two-bedroom floor plans tailored to fit your lifestyle. With stunning interiors and a vibrant community, your ideal home awaits. Browse our available apartments today and embrace a new standard of living in the heart of Reno!",
  "property_home_gallery_blurb": "Welcome to Reno Vista Apartments, where comfort meets convenience in vibrant Reno, NV. Choose from stylish one or two-bedroom layouts, complete with modern amenities like stainless steel appliances, a cozy courtyard, and a pet-friendly play area. Picture yourself enjoying scenic walking trails, social events, and effortless online services right at your fingertips!",
  "property_home_neighborhood_blurb": "Welcome to Reno Vista Apartments, your gateway to vibrant living in Reno, NV! Enjoy spacious one and two-bedroom floor plans, while being just moments from cultural gems like the Nevada Museum of Art, beautiful parks, and the Downtown Reno Library. Experience convenience and recreation right at your doorstep!",
  "property_home_reviews_blurb": "Welcome to Reno Vista Apartments, where breathtaking views of Reno's skyline blend seamlessly with a welcoming community. Our residents rave about the \"quiet and friendly neighbors,\" and our attentive management’s commitment to prompt repairs. Enjoy the convenience of nearby amenities while experiencing the beauty of both city and mountains. Check out what our residents have to say!",
  "property_neighborhood_blurb": "At Reno Vista Apartments, embrace a vibrant lifestyle surrounded by cultural treasures and outdoor adventures. Just moments away, engage with the National Automobile Museum, revel in the beauty of Idlewild Park, or catch a game at Greater Nevada Field. Dive into the local scene and connect with all that Reno has to offer!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Reno Vista Apartments in scenic Reno, NV, enjoy spacious one and two-bedroom homes paired with exceptional amenities. From a vibrant playground to serene walking trails, your perfect retreat awaits. Embrace community living with planned social activities, pet-friendly spaces, and modern features like stainless steel appliances and granite countertops.",
  "property_applynow_blurb": "At Reno Vista Apartments, spacious one and two-bedroom layouts blend comfort with modern design. Our vibrant community offers outstanding amenities—from a pet-friendly playground to serene walking trails. Enjoy cooking in your island kitchen with granite countertops and unwind on your private balcony. Begin your new chapter today!",
  "property_contactus_blurb": "At Reno Vista Apartments in vibrant Reno, NV, you'll find thoughtfully designed one and two-bedroom floor plans that cater to your lifestyle. Each space reflects modern comfort and style, making home truly special. Have questions? Our leasing team is eager to assist—reach out today for personalized guidance!",
  "property_faqs_blurb": "At Reno Vista Apartments in beautiful Reno, NV, your perfect home awaits. Choose from spacious one or two-bedroom layouts designed for comfort and style. Curious about our community? Our FAQs page has all the answers you need. Dive in and discover the lifestyle you've been looking for!",
  "property_floorplans_blurb": "At Reno Vista Apartments in picturesque Reno, NV, your ideal living space awaits. Choose from our thoughtfully designed one- and two-bedroom floor plans, tailored for comfort and style. Venture through a vibrant community that reflects your lifestyle—browse our available apartment homes and make your next move a reality!",
  "property_gallery_blurb": "At Reno Vista Apartments in vibrant Reno, NV, envision your life nestled in spacious one and two-bedroom layouts, complete with modern amenities like granite countertops and stainless steel appliances. Unwind in our serene courtyard, enjoy planned social activities, or let your pets roam freely in our play area. Picture yourself living here!",
  "property_interactivemap_blurb": "Welcome to Reno Vista Apartments in beautiful Reno, NV! Our range of spacious one and two-bedroom floor plans caters to your lifestyle. Enjoy amenities like a pet-friendly play area, modern kitchens with granite countertops, and lush walking trails. Use our interactive community map to find your perfect home today!",
  "property_pets_blurb": "Welcome to Reno Vista Apartments, where comfort meets community in beautiful Reno, NV. Embrace life with your furry friends in our pet-friendly homes, featuring spacious layouts and scenic views. With thoughtful amenities and a vibrant atmosphere, your ideal living experience awaits at Reno Vista—where every bark is a welcome sound!",
  "property_referafriend_blurb": "At Reno Vista Apartments in vibrant Reno, NV, our welcoming community invites you to experience the perfect blend of comfort and connection. With spacious one and two-bedroom floor plans, there’s a perfect space for you and your friends. Great friends make great neighbors—refer a friend today!",
  "property_residentaccess_blurb": "At Reno Vista Apartments in vibrant Reno, NV, our thoughtfully designed one and two-bedroom floor plans cater to your lifestyle needs. Enhance your living experience—access our resident portal anytime to effortlessly pay rent, schedule maintenance, and stay connected with your community. Your convenient life begins here!",
  "property_reviews_blurb": "At Reno Vista Apartments, residents rave about the stunning city and mountain views, and friendly, quiet neighbors. With prompt maintenance and a dedicated office team, you’ll feel right at home. Our community offers convenient access to stores and schools, making life easy. **\"Our view of Reno is amazing at night!\"** See what our residents have to say about living at our community!",
  "property_created_at": "1761592565531",
  "property_scheduletour_blurb": "At Reno Vista Apartments in lively Reno, NV, find your ideal space with our thoughtfully designed one and two-bedroom floor plans. Experience the vibrant community and comfort our residents cherish. Ready to see why they love calling us home? Schedule a tour today and step into your new lifestyle!",
  "property_thankyou_blurb": "Thank you for reaching out to Reno Vista Apartments in beautiful Reno, NV! Our spacious one- and two-bedroom floor plans combine comfort with style, perfect for your lifestyle. A member of our friendly team will be in touch soon to answer your questions and help you find your ideal home.",
  "property_virtualtours_blurb": "Welcome to Reno Vista Apartments in beautiful Reno, NV, where modern living meets comfort. Choose from spacious one and two-bedroom floor plans designed for your lifestyle. Dive into a virtual tour of our vibrant community and see your future home come to life—your perfect retreat awaits!",
  "property_copyright": "2025 All Rights Reserved. Reno Vista Apartments",
  "property_seo_title_home": "Reno Vista Apartments |  Apartments in Reno, NV",
  "property_seo_description_home": "Experience comfort at Reno Vista Apartments in NV! From spacious floor plans to fun amenities, your new home awaits. Join our vibrant community today!",
  "property_seo_title_floorplans": "Floor Plans | Reno, NV Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal space at Reno Vista Apartments in Reno, NV. With spacious one and two-bedroom floor plans, the perfect home awaits you—browse today!",
  "property_seo_title_amenities": "Amenities | Reno, NV Apartments for Rent",
  "property_seo_description_amenities": "Experience comfort at Reno Vista Apartments in Reno, NV! From spacious floor plans to fun amenities, find your perfect home in a vibrant community today!",
  "property_seo_title_gallery": "Gallery | Apartments in Reno, NV",
  "property_seo_description_gallery": "Experience comfort at Reno Vista Apartments. Enjoy spacious layouts, stunning amenities, and inviting outdoor spaces. Live your dream!",
  "property_seo_title_virtualtours": "Virtual Tours | Reno Vista Apartments Apartments",
  "property_seo_description_virtualtours": "Explore Reno Vista Apartments! Take our virtual tour and imagine your life in spacious one and two-bedroom homes in lovely Reno, NV.",
  "property_seo_title_interactivemap": "Interactive Map | Reno Vista Apartments Apartments",
  "property_seo_description_interactivemap": "Find your perfect space at Reno Vista Apartments in Reno, NV! Use our interactive map to explore stunning floor plans and discover your new home today!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Reno, NV",
  "property_seo_description_neighborhood": "Discover Reno's charm at Reno Vista Apartments, where vibrant local favorites and exciting attractions are just steps away!",
  "property_seo_title_contact": "Contact Us | Reno Vista Apartments",
  "property_seo_description_contact": "Connect with the Reno Vista Apartments team in Reno, NV! Inquire about our spacious one and two-bedroom floor plans. Your new home awaits!",
  "property_seo_title_faqs": "FAQs | Apartments in Reno, NV",
  "property_seo_description_faqs": "Find answers to your questions about Reno Vista Apartments! From amenities to floor plans, explore what makes our community in Reno, NV the perfect home.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Reno, NV",
  "property_seo_description_reviews": "Join the Reno Vista Apartments family! Check out resident reviews & see why our community is the perfect blend of comfort, amenities, and vibrant living.",
  "property_seo_title_applynow": "Apply Now | Apartments in Reno, NV",
  "property_seo_description_applynow": "Find your ideal home at Reno Vista Apartments in Reno, NV! Enjoy spacious layouts, modern amenities, and a vibrant community. Lease online today!",
  "property_seo_title_residentaccess": "Resident Access | Reno Vista Apartments",
  "property_seo_description_residentaccess": "Seamlessly manage your living experience at Reno Vista Apartments. Log in to your resident portal to pay rent, request maintenance, and stay connected today!",
  "property_seo_title_referafriend": "Refer A Friend | Reno Vista Apartments",
  "property_seo_description_referafriend": "Refer a friend to Reno Vista Apartments! Great neighbors make our community shine. Share the love and enjoy upgraded living together in beautiful Reno, NV!",
  "property_seo_title_scheduletour": "Schedule a Tour | Reno Vista Apartments",
  "property_seo_description_scheduletour": "Discover the charm of Reno Vista Apartments! Schedule a tour today and imagine your new life just minutes from downtown Reno.",
  "property_seo_title_privacy": "Privacy Policy | Reno Vista Apartments",
  "property_seo_description_privacy": "Your privacy matters! Discover how Reno Vista Apartments in Reno, NV protects your info for a secure, comfortable living experience. Read our policy.",
  "property_seo_title_accessibility": "Website Accessibility | Reno Vista Apartments",
  "property_seo_description_accessibility": "At Reno Vista Apartments, we champion digital inclusion and accessibility, ensuring everyone feels at home in beautiful Reno, NV. Join us!",
  "property_seo_title_sitemap": "Sitemap | Reno Vista Apartments",
  "property_seo_description_sitemap": "Find your way around Reno Vista Apartments! Check out our sitemap for easy navigation to amenities, floor plans, and more in beautiful Reno, NV.",
  "property_seo_title_thankyou": "Thank You | Reno Vista Apartments",
  "property_seo_description_thankyou": "Thank you for reaching out to Reno Vista Apartments! A team member will connect with you soon to help you find your perfect home in beautiful Reno, NV.",
  "property_seo_title_pets": "Pet Policy | Apartments in Reno, NV",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1787688455566",
  "amenities": [
    {
      "id": "ec_8e5052544ee338ce8e86b31f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166657",
      "source": "generator",
      "external_id": "false",
      "title": "Resident Referral Programs",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_26fe93bb18a681d033a2e388",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166657",
      "source": "generator",
      "external_id": "false",
      "title": "Professional Management",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_087b724fd793099f742d14db",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166657",
      "source": "generator",
      "external_id": "false",
      "title": "Great Neighborhood",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1bda153281f8f61984316b88",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166657",
      "source": "generator",
      "external_id": "false",
      "title": "24 hr Emergency Maintenance Service",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_99d4d53851735c3c1bf24368",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166657",
      "source": "generator",
      "external_id": "false",
      "title": "Convenient Location",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6ff5cea8676dd3508dc12b15",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166657",
      "source": "generator",
      "external_id": "false",
      "title": "Guest Parking",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1fa51f2302230fb7386d80a1",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166657",
      "source": "generator",
      "external_id": "false",
      "title": "Professional Management Team",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_01983b46e1ec827ca3eb54ac",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166657",
      "source": "generator",
      "external_id": "false",
      "title": "Pet Exercise Park",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_24882c1db480fe6497cdd640",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166657",
      "source": "generator",
      "external_id": "false",
      "title": "Pest Control Service",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3f100a76278c6e7981219a3e",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166657",
      "source": "generator",
      "external_id": "false",
      "title": "Emergency Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e45f340b609b1edcdf999a11",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166657",
      "source": "generator",
      "external_id": "false",
      "title": "Public Transportation",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_866c0a95ba1591f5f21f90ab",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166657",
      "source": "generator",
      "external_id": "false",
      "title": "Playground",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c57460244b433956c97eef5d",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166657",
      "source": "generator",
      "external_id": "false",
      "title": "Pet Friendly",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5be2b356c3d204f6deb19928",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166657",
      "source": "generator",
      "external_id": "false",
      "title": "Bilingual",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8140db9e09795d41dd9c6c1e",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166657",
      "source": "generator",
      "external_id": "false",
      "title": "Freeway Access",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9884c767a3197fdb92fffb49",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166657",
      "source": "generator",
      "external_id": "false",
      "title": "Internet Access",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3f07fedf4faed92f3464ff9e",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166657",
      "source": "generator",
      "external_id": "false",
      "title": "Surface Lot",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6406a1d76887093434f84a2c",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166657",
      "source": "generator",
      "external_id": "false",
      "title": "Large Bedrooms",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8935825c336fe92c3c41a98f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166657",
      "source": "generator",
      "external_id": "false",
      "title": "Carpeting",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0547b68c4d7800803579f9af",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166657",
      "source": "generator",
      "external_id": "false",
      "title": "Garbage Disposal",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6b6529bb7f589e8fb8466f8a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166657",
      "source": "generator",
      "external_id": "false",
      "title": "Electric Stove",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b55d00d19a4e8b7ab410ea7a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166657",
      "source": "generator",
      "external_id": "false",
      "title": "Private Balconies/Patios",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_29cfa920ddacb0f422e14445",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166657",
      "source": "generator",
      "external_id": "false",
      "title": "Spectacular City & Mountain Views",
      "amount": "false",
      "description": "Select Units Only",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5caf956302b7caa8835b0c13",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166657",
      "source": "generator",
      "external_id": "false",
      "title": "Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f8a34c05baf00e37c16e3541",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166657",
      "source": "generator",
      "external_id": "false",
      "title": "Ceiling Fans",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_89f9c9dc9d3f35e930934e55",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166657",
      "source": "generator",
      "external_id": "false",
      "title": "Deadbolt Entry lock w/ Privacy View",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_da52edde49029c9976b0c93a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166657",
      "source": "generator",
      "external_id": "false",
      "title": "Conventional Kitchen",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_72cf391cf864a75ba33a222a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166657",
      "source": "generator",
      "external_id": "false",
      "title": "Individual Hot Water Heaters",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_42a3d523149b6e239fdc5e54",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166657",
      "source": "generator",
      "external_id": "false",
      "title": "Air Conditioning",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_49b50f3ec6fd97ab40a792d9",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166657",
      "source": "generator",
      "external_id": "false",
      "title": "Ceiling Fan",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b20da5d8cf4f004ec4e986e7",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166657",
      "source": "generator",
      "external_id": "false",
      "title": "Washer Dryer In Unit",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8d84d451ce07ce9435e1f295",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166657",
      "source": "generator",
      "external_id": "false",
      "title": "Window Covering",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_cf5c3c1c59482be840c30ee8",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166657",
      "source": "generator",
      "external_id": "false",
      "title": "Cable Ready",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f8098a5db44e74dab3ee8a82",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166657",
      "source": "generator",
      "external_id": "false",
      "title": "View",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fe2445109b9401974e8ede22",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166657",
      "source": "generator",
      "external_id": "false",
      "title": "Patio or Balcony",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_dc11bf7d-dbf9-4c20-a634-c1bf7e27f085",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166657",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166657/019d02cf-0caa-70bc-9f92-6e9e8dbafe14.webp",
      "image_media": {
        "alt_text": "Cozy bedroom with a queen-size bed, orange throw blanket, and modern decor.",
        "public_id": "019d02cf-0caa-70bc-9f92-6e9e8dbafe14",
        "storage_key": "property/6767906449166657/019d02cf-0caa-70bc-9f92-6e9e8dbafe14.webp",
        "width": 800,
        "height": 600
      },
      "title": "Apartment",
      "description": "Relax and unwind in this stylish bedroom, featuring a comfortable queen-size bed, modern furnishings, and a warm, inviting atmosphere.",
      "link": "",
      "alt_text": "Cozy bedroom with a queen-size bed, orange throw blanket, and modern decor.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_8db58bb2-dc92-4c64-8524-595a1ac9863a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166657",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166657/019d02cf-0b99-721d-81f5-e0b24a481743.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark cabinets, white countertops, and stainless steel appliances.",
        "public_id": "019d02cf-0b99-721d-81f5-e0b24a481743",
        "storage_key": "property/6767906449166657/019d02cf-0b99-721d-81f5-e0b24a481743.webp",
        "width": 800,
        "height": 600
      },
      "title": "Apartment",
      "description": "This apartment kitchen features dark wood cabinets, ample counter space, a dishwasher, and a full-size refrigerator.",
      "link": "",
      "alt_text": "Modern kitchen with dark cabinets, white countertops, and stainless steel appliances.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_f6332a36-83b2-44bb-9598-a90d19f1ad56",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166657",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166657/019d02cf-0836-70c8-a831-757ef5a73d2f.webp",
      "image_media": {
        "alt_text": "Dining area and kitchen with washer and dryer in an apartment.",
        "public_id": "019d02cf-0836-70c8-a831-757ef5a73d2f",
        "storage_key": "property/6767906449166657/019d02cf-0836-70c8-a831-757ef5a73d2f.webp",
        "width": 800,
        "height": 600
      },
      "title": "Apartment",
      "description": "Enjoy meals in the dining area or prepare them in the full kitchen, complete with a washer and dryer for your convenience.",
      "link": "",
      "alt_text": "Dining area and kitchen with washer and dryer in an apartment.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_551510e4-70c4-4f1b-981a-a30cfa6343bf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166657",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166657/019d02cf-049d-711b-92a9-199aab828b38.webp",
      "image_media": {
        "alt_text": "Living room and dining area in an apartment with modern furniture.",
        "public_id": "019d02cf-049d-711b-92a9-199aab828b38",
        "storage_key": "property/6767906449166657/019d02cf-049d-711b-92a9-199aab828b38.webp",
        "width": 800,
        "height": 600
      },
      "title": "Apartment",
      "description": "Stylish living and dining area with comfortable seating, a flat-screen TV, and a glass dining table, perfect for entertaining.",
      "link": "",
      "alt_text": "Living room and dining area in an apartment with modern furniture.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_71ba41f6-e581-4cfe-af4f-f1ad9716d9bb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166657",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166657/019d02cf-0182-702a-b3b3-71937cb1b8f5.webp",
      "image_media": {
        "alt_text": "A bright living room with a blue sofa, modern coffee table, side tables, and abstract art.",
        "public_id": "019d02cf-0182-702a-b3b3-71937cb1b8f5",
        "storage_key": "property/6767906449166657/019d02cf-0182-702a-b3b3-71937cb1b8f5.webp",
        "width": 800,
        "height": 600
      },
      "title": "Apartment",
      "description": "Step into comfort and style in this beautifully appointed living room, featuring a plush blue sofa, chic marble coffee table, and elegant abstract artwork.",
      "link": "",
      "alt_text": "A bright living room with a blue sofa, modern coffee table, side tables, and abstract art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_fd542fca-42f5-43e8-ad89-560d2f0d3db1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166657",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166657/019d02ce-ffdc-71f9-b800-36167c360ce7.webp",
      "image_media": {
        "alt_text": "Living room with blue sofa, coffee table, and white armchair.",
        "public_id": "019d02ce-ffdc-71f9-b800-36167c360ce7",
        "storage_key": "property/6767906449166657/019d02ce-ffdc-71f9-b800-36167c360ce7.webp",
        "width": 800,
        "height": 600
      },
      "title": "Apartment",
      "description": "Stylish living room featuring a vibrant blue sofa, marble coffee table, and plush white rug, perfect for relaxation and entertaining.",
      "link": "",
      "alt_text": "Living room with blue sofa, coffee table, and white armchair.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e6763792-405d-4bb3-8bc5-3c86a4b239b1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166657",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166657/019d02ce-f9d6-7162-9dac-6e74913b5f29.webp",
      "image_media": {
        "alt_text": "Modern living room with blue sofa, white armchair, coffee table, and TV mounted on wall.",
        "public_id": "019d02ce-f9d6-7162-9dac-6e74913b5f29",
        "storage_key": "property/6767906449166657/019d02ce-f9d6-7162-9dac-6e74913b5f29.webp",
        "width": 800,
        "height": 600
      },
      "title": "Apartment",
      "description": "Step into comfort in this stylish living area, featuring a plush blue sofa, elegant armchair, and a sleek entertainment unit.",
      "link": "",
      "alt_text": "Modern living room with blue sofa, white armchair, coffee table, and TV mounted on wall.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_aead4f6f-b17f-4b72-aefa-0eb9b2625ea3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166657",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166657/019d02ce-f5e8-7589-a2e4-259b8c2ac5cc.webp",
      "image_media": {
        "alt_text": "Dog park with agility equipment and a bench.",
        "public_id": "019d02ce-f5e8-7589-a2e4-259b8c2ac5cc",
        "storage_key": "property/6767906449166657/019d02ce-f5e8-7589-a2e4-259b8c2ac5cc.webp",
        "width": 800,
        "height": 600
      },
      "title": "Community",
      "description": "Enjoy our spacious dog park, complete with agility equipment for your furry friends and a relaxing bench for owners.",
      "link": "",
      "alt_text": "Dog park with agility equipment and a bench.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_fa6f4651-97c8-44d9-bc6f-6e8e83b8b9fe",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166657",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166657/019d02ce-f41c-7149-aa42-6aaa476ecf01.webp",
      "image_media": {
        "alt_text": "Playground with slides and picnic tables.",
        "public_id": "019d02ce-f41c-7149-aa42-6aaa476ecf01",
        "storage_key": "property/6767906449166657/019d02ce-f41c-7149-aa42-6aaa476ecf01.webp",
        "width": 800,
        "height": 600
      },
      "title": "Community",
      "description": "Enjoy outdoor fun at our community playground, complete with slides and picnic tables for family gatherings.",
      "link": "",
      "alt_text": "Playground with slides and picnic tables.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c2707a19-de43-4b1e-a004-ef9568feb7b5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166657",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166657/019d02ce-ee11-7277-acaa-e654aff15fc3.webp",
      "image_media": {
        "alt_text": "Playground with slides, picnic tables, and a BBQ grill.",
        "public_id": "019d02ce-ee11-7277-acaa-e654aff15fc3",
        "storage_key": "property/6767906449166657/019d02ce-ee11-7277-acaa-e654aff15fc3.webp",
        "width": 800,
        "height": 600
      },
      "title": "Community",
      "description": "Enjoy outdoor fun and gatherings with a spacious playground, convenient picnic tables, and a BBQ grill area.",
      "link": "",
      "alt_text": "Playground with slides, picnic tables, and a BBQ grill.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_886b4dd2-f190-4920-8ac1-f5c333157c78",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166657",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166657/019d02ce-e8c7-77ba-a1f0-d9ae64fc0528.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with parking lot.",
        "public_id": "019d02ce-e8c7-77ba-a1f0-d9ae64fc0528",
        "storage_key": "property/6767906449166657/019d02ce-e8c7-77ba-a1f0-d9ae64fc0528.webp",
        "width": 800,
        "height": 600
      },
      "title": "Community",
      "description": "Exterior view of apartment buildings with a parking lot in the foreground. Features dark gray siding and white trim, with trees and landscaping.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings with parking lot.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_faff901e-bf68-4177-a29f-d85c57880480",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166657",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166657/019d02ce-e74c-7119-92e2-c03fbc63f1f6.webp",
      "image_media": {
        "alt_text": "Reno Vista apartment building entrance with awning and stairs.",
        "public_id": "019d02ce-e74c-7119-92e2-c03fbc63f1f6",
        "storage_key": "property/6767906449166657/019d02ce-e74c-7119-92e2-c03fbc63f1f6.webp",
        "width": 800,
        "height": 600
      },
      "title": "Community",
      "description": "Exterior view of the Reno Vista apartment building entrance, featuring an awning, stairs, and decorative fall flowers.",
      "link": "",
      "alt_text": "Reno Vista apartment building entrance with awning and stairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_96de31d0-e982-44bb-9da2-0a02aefac161",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166657",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166657/019d02ce-e3c9-759d-bd7a-bbc012ba5d5b.webp",
      "image_media": {
        "alt_text": "Reno Vista Panorama Village monument sign with landscaping.",
        "public_id": "019d02ce-e3c9-759d-bd7a-bbc012ba5d5b",
        "storage_key": "property/6767906449166657/019d02ce-e3c9-759d-bd7a-bbc012ba5d5b.webp",
        "width": 800,
        "height": 600
      },
      "title": "Community",
      "description": "Welcome to Reno Vista Panorama Village, featuring a beautifully landscaped monument sign at the entrance.",
      "link": "",
      "alt_text": "Reno Vista Panorama Village monument sign with landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_e2a0b552-a6dc-493c-af47-93c9441d7ad6",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166657",
      "source": "custom",
      "poi_name": "In-N-Out Burger",
      "poi_type": "Restaurants",
      "poi_address": "280 Pyramid Way, Sparks, NV 89431, USA",
      "poi_short_description": "Fast-food burgers, fries and shakes joint with a drive-through and friendly service.",
      "poi_long_description": "People say this hamburger restaurant serves delicious cheeseburgers, animal style fries, and shakes. They highlight the reasonable prices and fast service. They also like the friendly staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166657/019d02cf-3e0a-721f-8d0b-3ceba648b565.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cf-3e0a-721f-8d0b-3ceba648b565",
        "storage_key": "property/6767906449166657/019d02cf-3e0a-721f-8d0b-3ceba648b565.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.in-n-out.com/188",
      "poi_directions_map_url": "https://maps.google.com/?cid=11026944158239102732&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "in-n-out-burger",
      "poi_latitude": "39.5354925",
      "poi_longitude": "-119.7525459",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 800-786-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166657/019d02cf-8c8d-72f6-98d2-0ed9e24cf485.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cf-8c8d-72f6-98d2-0ed9e24cf485",
        "storage_key": "property/6767906449166657/019d02cf-8c8d-72f6-98d2-0ed9e24cf485.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ65xY1lPRhIARDBfp5UmTB5k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hamburger_restaurant"
    },
    {
      "id": "custom_c837d9e6-54ad-4ae6-8671-aa8264fc2bcf",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166657",
      "source": "custom",
      "poi_name": "Chick-fil-A",
      "poi_type": "Restaurants",
      "poi_address": "6365 S McCarran Blvd, Reno, NV 89509, USA",
      "poi_short_description": "Fast-food chain serving chicken sandwiches & nuggets along with salads & sides.",
      "poi_long_description": "People say this fast food restaurant serves delicious chicken sandwiches. They also highlight the fast service and friendly staff.\n\nOther reviews mention the drive thru can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166657/019d02cf-3e05-7059-af54-a0b563a2b54f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cf-3e05-7059-af54-a0b563a2b54f",
        "storage_key": "property/6767906449166657/019d02cf-3e05-7059-af54-a0b563a2b54f.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://www.chick-fil-a.com/locations/nv/south-mccarran-and-580?utm_source=yext&utm_medium=link",
      "poi_directions_map_url": "https://maps.google.com/?cid=14777856888137327737&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chick-fil-a",
      "poi_latitude": "39.4773484",
      "poi_longitude": "-119.7921256",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 36 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 775-470-8333",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166657/019d02cf-8c8d-72f6-98d2-0ed9e24cf485.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cf-8c8d-72f6-98d2-0ed9e24cf485",
        "storage_key": "property/6767906449166657/019d02cf-8c8d-72f6-98d2-0ed9e24cf485.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4fgZHnVAmYAReST8Fot-Fc0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_89082033-e343-4594-8de6-ab969c899005",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166657",
      "source": "custom",
      "poi_name": "Two Chicks",
      "poi_type": "Restaurants",
      "poi_address": "752 S Virginia St, Reno, NV 89501, USA",
      "poi_short_description": "Industrial-chic eatery offering local, seasonal American breakfasts, sandwich melts & salads.",
      "poi_long_description": "People say this brunch restaurant serves delicious biscuits and gravy, huevos rancheros, and French toast. They highlight the generous portions, reasonable prices, and quick service. They also like the friendly and attentive staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166657/019d02cf-3de6-70cd-b071-d3d191783d69.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cf-3de6-70cd-b071-d3d191783d69",
        "storage_key": "property/6767906449166657/019d02cf-3de6-70cd-b071-d3d191783d69.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.twochicksreno.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9878472336574534787&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "two-chicks",
      "poi_latitude": "39.5185518",
      "poi_longitude": "-119.8088841",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 34 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 775-323-0600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166657/019d02cf-8c8d-72f6-98d2-0ed9e24cf485.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cf-8c8d-72f6-98d2-0ed9e24cf485",
        "storage_key": "property/6767906449166657/019d02cf-8c8d-72f6-98d2-0ed9e24cf485.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJlQjbKrhAmYARg1QMcUBiF4k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "brunch_restaurant"
    },
    {
      "id": "custom_c5e0cdee-03bb-463f-ae90-934a222231ea",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166657",
      "source": "custom",
      "poi_name": "Reno Public Market",
      "poi_type": "Restaurants",
      "poi_address": "299 E Plumb Ln, Reno, NV 89502, USA",
      "poi_short_description": "Relaxed food hall featuring numerous locally owned eateries and retailers plus live entertainment.",
      "poi_long_description": "People say this restaurant offers a wide variety of food options, including pizza, pupusas, and ramen, and a selection of drinks. They also highlight the fun, lively atmosphere with live music, dancing, and games, and the friendly staff.\n\nOther reviews mention the food can be expensive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166657/019d02cf-474a-74a8-81a5-3ffe2dd5c91c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cf-474a-74a8-81a5-3ffe2dd5c91c",
        "storage_key": "property/6767906449166657/019d02cf-474a-74a8-81a5-3ffe2dd5c91c.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.renopublicmarket.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1674061056551160090&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "reno-public-market",
      "poi_latitude": "39.5065642",
      "poi_longitude": "-119.8021424",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 45 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 775-993-3220",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166657/019d02cf-8c8d-72f6-98d2-0ed9e24cf485.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cf-8c8d-72f6-98d2-0ed9e24cf485",
        "storage_key": "property/6767906449166657/019d02cf-8c8d-72f6-98d2-0ed9e24cf485.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJYevhQpdAmYARGgkMUKl1Oxc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_1eb15897-5547-4024-9329-be8ac0462e08",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166657",
      "source": "custom",
      "poi_name": "Trader Joe's",
      "poi_type": "Shopping & Retail",
      "poi_address": "5035 S McCarran Blvd, Reno, NV 89502, USA",
      "poi_short_description": "Casual grocery store chain known for its unique private-label goods.",
      "poi_long_description": "People say this grocery store offers a wide selection of fresh produce, cheese, bread, snacks, and unique products, including organic and gluten-free options. They highlight the affordable prices, healthy options, and interesting finds, as well as the clean and well-stocked store. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166657/019d02cf-46f2-72af-9617-8816813ca3d2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cf-46f2-72af-9617-8816813ca3d2",
        "storage_key": "property/6767906449166657/019d02cf-46f2-72af-9617-8816813ca3d2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.traderjoes.com/nv/reno/82/?utm_source=gmb&utm_medium=organic&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=17515109851821739607&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "trader-joes",
      "poi_latitude": "39.4787891",
      "poi_longitude": "-119.7839949",
      "poi_miles_from_property": "7.2",
      "poi_walking_minutes": "2 hours 38 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 775-826-1621",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166657/019d02cf-8cd1-74f9-a778-ecd8ab3847c7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cf-8cd1-74f9-a778-ecd8ab3847c7",
        "storage_key": "property/6767906449166657/019d02cf-8cd1-74f9-a778-ecd8ab3847c7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJOYZnvvQ_mYARV47Hd5wrEvM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_6f2f4605-e945-45f2-8e0a-2c17cced1444",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166657",
      "source": "custom",
      "poi_name": "WinCo Foods",
      "poi_type": "Shopping & Retail",
      "poi_address": "2855 Northtowne Ln, Reno, NV 89512, USA",
      "poi_short_description": "Vast, clean store, featuring self-checkout lanes, for produce, deli goods, baked goods and bulk-bin basics.",
      "poi_long_description": "Shoppers say this supermarket offers a wide variety of groceries, including fresh produce, high-quality meats, and a great selection of products. They also highlight the low prices and friendly staff.\n\nSome reviews mention the checkout lines can be long.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166657/019d02cf-471d-72f9-b514-35b86e9bc60d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cf-471d-72f9-b514-35b86e9bc60d",
        "storage_key": "property/6767906449166657/019d02cf-471d-72f9-b514-35b86e9bc60d.webp",
        "width": 1280,
        "height": 958
      },
      "poi_business_url": "http://www.wincofoods.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7467129787320583567&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "winco-foods",
      "poi_latitude": "39.553496",
      "poi_longitude": "-119.784073",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 775-331-6966",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166657/019d02cf-8cd1-74f9-a778-ecd8ab3847c7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cf-8cd1-74f9-a778-ecd8ab3847c7",
        "storage_key": "property/6767906449166657/019d02cf-8cd1-74f9-a778-ecd8ab3847c7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJXbg6ppg4mYARj0X7oPqSoGc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_f43a148d-8fce-42d2-b9f1-63d3397874bc",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166657",
      "source": "custom",
      "poi_name": "The Outlets at Legends",
      "poi_type": "Shopping & Retail",
      "poi_address": "1310 Scheels Drive, Sparks, NV 89434, USA",
      "poi_short_description": "Mall offering shops and restaurants, along with a casino, a movie theater, and a ferris wheel.",
      "poi_long_description": "People say this shopping center offers a wide variety of shops, including outlets, and a movie theater. They highlight the good deals, the clean and walkable outdoor mall layout, and the interesting sculptures and fountains. They also like the comfortable seating areas and the pavilion with a fireplace.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166657/019d02cf-470f-73f6-8db3-44026ab69a6c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cf-470f-73f6-8db3-44026ab69a6c",
        "storage_key": "property/6767906449166657/019d02cf-470f-73f6-8db3-44026ab69a6c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.reddevelopment.com/outlets-at-legends/?utm_source=google&utm_medium=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=9221991968604415767&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-outlets-at-legends",
      "poi_latitude": "39.5316589",
      "poi_longitude": "-119.7208903",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 6 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 775-358-3800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166657/019d02cf-8cdb-72ee-8685-1d067633ab5e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cf-8cdb-72ee-8685-1d067633ab5e",
        "storage_key": "property/6767906449166657/019d02cf-8cdb-72ee-8685-1d067633ab5e.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJyWg1Eus-mYARF-cr0tUY-38",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_a084564f-3adf-421b-ac1d-28501d23f1ab",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166657",
      "source": "custom",
      "poi_name": "Sprouts Farmers Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "299 E Plumb Ln Suite 120, Reno, NV 89502, USA",
      "poi_short_description": "Chain grocery offering health foods, produce, and other organic products, plus prepared foods.",
      "poi_long_description": "People say this grocery store offers fresh produce, a wide selection of products, and a deli with delicious sandwiches. They also highlight the friendly and helpful staff, and the clean and well-organized store.\n\nOther reviews mention the prices can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166657/019d02cf-5125-7105-9ea0-39e565d50ea1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cf-5125-7105-9ea0-39e565d50ea1",
        "storage_key": "property/6767906449166657/019d02cf-5125-7105-9ea0-39e565d50ea1.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.sprouts.com/store/nv/reno/reno-sparks/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1021220747616628218&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sprouts-farmers-market",
      "poi_latitude": "39.5068042",
      "poi_longitude": "-119.8009451",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 43 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 775-446-3979",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166657/019d02cf-8cd1-74f9-a778-ecd8ab3847c7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cf-8cd1-74f9-a778-ecd8ab3847c7",
        "storage_key": "property/6767906449166657/019d02cf-8cd1-74f9-a778-ecd8ab3847c7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJLwfLjOBBmYAR-q3y-tsaLA4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_d9e96681-b3de-4db6-9ec2-b011846d6c98",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166657",
      "source": "custom",
      "poi_name": "The Home Depot",
      "poi_type": "Shopping & Retail",
      "poi_address": "2955 Northtowne Ln, Reno, NV 89512, USA",
      "poi_short_description": "Home improvement store carrying everything from tools and paint to appliances, cabinets, and lumber.",
      "poi_long_description": "People say this home improvement store offers a wide variety of products, including succulent food, orchid food, flowers, soil, and fertilizer. They also highlight the helpful and friendly staff, and the convenient hours.\n\nOther reviews mention the store can be large.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166657/019d02cf-5031-777b-a0de-da0d5d4c37cc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cf-5031-777b-a0de-da0d5d4c37cc",
        "storage_key": "property/6767906449166657/019d02cf-5031-777b-a0de-da0d5d4c37cc.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.homedepot.com/l/N-Reno/NV/Reno/89512/3304?emt=MSGMBGoogleMaps",
      "poi_directions_map_url": "https://maps.google.com/?cid=17471747494268246602&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-home-depot",
      "poi_latitude": "39.55725169999999",
      "poi_longitude": "-119.7841488",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 775-674-2900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166657/019d02cf-8cdb-72ee-8685-1d067633ab5e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cf-8cdb-72ee-8685-1d067633ab5e",
        "storage_key": "property/6767906449166657/019d02cf-8cdb-72ee-8685-1d067633ab5e.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ4VTFvZ44mYARShou2cYdePI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_50bb937f-857a-44bd-9a1f-91a04705ede0",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166657",
      "source": "custom",
      "poi_name": "University of Nevada, Reno",
      "poi_type": "Education",
      "poi_address": "1664 N Virginia St, Reno, NV 89557, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166657/019d02cf-4fee-725b-ba0b-2aea4423c179.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cf-4fee-725b-ba0b-2aea4423c179",
        "storage_key": "property/6767906449166657/019d02cf-4fee-725b-ba0b-2aea4423c179.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.unr.edu/?utm_source=google&utm_medium=organic&utm_campaign=knowledge-panel",
      "poi_directions_map_url": "https://maps.google.com/?cid=16394618361528374808&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "university-of-nevada-reno",
      "poi_latitude": "39.5485651",
      "poi_longitude": "-119.8156924",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 775-784-1110",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166657/019d02cf-8ce1-745e-bf73-5a50c5c06dfa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cf-8ce1-745e-bf73-5a50c5c06dfa",
        "storage_key": "property/6767906449166657/019d02cf-8ce1-745e-bf73-5a50c5c06dfa.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJH9FLh9dGmYARGNb-koliheM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_bef7b362-8693-49eb-986a-d1d9aa85a547",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166657",
      "source": "custom",
      "poi_name": "Truckee Meadows Community College (TMCC)",
      "poi_type": "Education",
      "poi_address": "7000 Dandini Blvd, Reno, NV 89512, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166657/019d02cf-4e8c-7767-b350-2b6bf979981e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cf-4e8c-7767-b350-2b6bf979981e",
        "storage_key": "property/6767906449166657/019d02cf-4e8c-7767-b350-2b6bf979981e.webp",
        "width": 1280,
        "height": 644
      },
      "poi_business_url": "https://www.tmcc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17097618161802842243&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "truckee-meadows-community-college-tmcc",
      "poi_latitude": "39.5722048",
      "poi_longitude": "-119.79705",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 775-673-7111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166657/019d02cf-8ce1-745e-bf73-5a50c5c06dfa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cf-8ce1-745e-bf73-5a50c5c06dfa",
        "storage_key": "property/6767906449166657/019d02cf-8ce1-745e-bf73-5a50c5c06dfa.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJFTHFC4NHmYARg5CGjyHxRu0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_37b29359-9df4-4a11-961a-4ae2f04054e5",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166657",
      "source": "custom",
      "poi_name": "Downtown Reno Library",
      "poi_type": "Education",
      "poi_address": "301 S Center St, Reno, NV 89501, USA",
      "poi_short_description": "Centrally-located library with a balcony art gallery, an auditorium, and materials on Nevada.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166657/019d02cf-566e-7687-b251-3d6112aca8b1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cf-566e-7687-b251-3d6112aca8b1",
        "storage_key": "property/6767906449166657/019d02cf-566e-7687-b251-3d6112aca8b1.webp",
        "width": 964,
        "height": 1280
      },
      "poi_business_url": "http://www.washoecountylibrary.us/libraries/downtown-reno.php",
      "poi_directions_map_url": "https://maps.google.com/?cid=16336555478702685690&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "downtown-reno-library",
      "poi_latitude": "39.5225316",
      "poi_longitude": "-119.8101561",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 775-327-8300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166657/019d02cf-8ce1-745e-bf73-5a50c5c06dfa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cf-8ce1-745e-bf73-5a50c5c06dfa",
        "storage_key": "property/6767906449166657/019d02cf-8ce1-745e-bf73-5a50c5c06dfa.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJcRlrdLZAmYAR-v2IMacat-I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_ed886606-1f44-4519-ba80-ba06a8c77051",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166657",
      "source": "custom",
      "poi_name": "Sparks Library",
      "poi_type": "Education",
      "poi_address": "1125 12th St, Sparks, NV 89431, USA",
      "poi_short_description": "Large public library featuring a computer lab, a community food pantry, and a gallery.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166657/019d02cf-5817-7603-b7e8-ce1ba118b086.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cf-5817-7603-b7e8-ce1ba118b086",
        "storage_key": "property/6767906449166657/019d02cf-5817-7603-b7e8-ce1ba118b086.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.washoecountylibrary.us/libraries/sparks.php",
      "poi_directions_map_url": "https://maps.google.com/?cid=15393713029405642363&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sparks-library",
      "poi_latitude": "39.5442247",
      "poi_longitude": "-119.7588834",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 775-352-3200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166657/019d02cf-8ce1-745e-bf73-5a50c5c06dfa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cf-8ce1-745e-bf73-5a50c5c06dfa",
        "storage_key": "property/6767906449166657/019d02cf-8ce1-745e-bf73-5a50c5c06dfa.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJL6q8i8w4mYARe44G3HB0odU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_d1aea734-b0f6-4d8b-8161-1bf3c01a382b",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166657",
      "source": "custom",
      "poi_name": "National Automobile Museum",
      "poi_type": "Entertainment",
      "poi_address": "1 Museum Dr, Reno, NV 89501, USA",
      "poi_short_description": "Themed displays with over 220 antique & vintage cars as well as educational & historical exhibits.",
      "poi_long_description": "People say this national museum offers an impressive collection of vintage cars, race cars, and movie vehicles, with displays organized by decade. They highlight the fun and informative experience, suitable for kids and car enthusiasts alike, and the well-maintained vehicles. They also like the friendly and knowledgeable staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166657/019d02cf-5849-741c-9b00-fed5f970e896.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cf-5849-741c-9b00-fed5f970e896",
        "storage_key": "property/6767906449166657/019d02cf-5849-741c-9b00-fed5f970e896.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.automuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1835301545631334084&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "national-automobile-museum",
      "poi_latitude": "39.526224",
      "poi_longitude": "-119.8083969",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 21 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 775-333-9300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166657/019d02cf-936a-7164-842b-ab745df4700f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cf-936a-7164-842b-ab745df4700f",
        "storage_key": "property/6767906449166657/019d02cf-936a-7164-842b-ab745df4700f.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJkSzJ-7RAmYARxL4UKwhNeBk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_511e91c2-9990-4433-8c86-24527abc8b8b",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166657",
      "source": "custom",
      "poi_name": "The Discovery",
      "poi_type": "Entertainment",
      "poi_address": "490 S Center St, Reno, NV 89501, USA",
      "poi_short_description": "Science & technology museum presenting interactive exhibits & temporary exhibitions.",
      "poi_long_description": "People say this science museum offers interactive exhibits, a play area for toddlers, and a gift shop. They highlight the membership is a great value and the activities are both fun and educational. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166657/019d02cf-5974-771c-b728-b87466470401.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cf-5974-771c-b728-b87466470401",
        "storage_key": "property/6767906449166657/019d02cf-5974-771c-b728-b87466470401.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://nvdm.org/?utm_source=gmb&utm_medium=organic&utm_campaign=the_discovery",
      "poi_directions_map_url": "https://maps.google.com/?cid=2712306752686923471&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-discovery",
      "poi_latitude": "39.5217683",
      "poi_longitude": "-119.8094121",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 30 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 775-786-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166657/019d02cf-936a-7164-842b-ab745df4700f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cf-936a-7164-842b-ab745df4700f",
        "storage_key": "property/6767906449166657/019d02cf-936a-7164-842b-ab745df4700f.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ75kT9bZAmYARzx7MA58MpCU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_6222ca8e-0db0-42c4-a465-570375dbcd24",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166657",
      "source": "custom",
      "poi_name": "Greater Nevada Field",
      "poi_type": "Entertainment",
      "poi_address": "250 Evans Ave Suite 101, Reno, NV 89501, USA",
      "poi_short_description": "Clean stadium known for baseball games and soccer games.",
      "poi_long_description": "People say this ballpark offers great baseball games, fireworks displays, and family-friendly entertainment. They highlight the easy entry and exit, quick vendor lines, and well-labeled seating, as well as the clean and safe environment. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166657/019d02cf-5e5c-7398-9240-77299e7057d9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cf-5e5c-7398-9240-77299e7057d9",
        "storage_key": "property/6767906449166657/019d02cf-5e5c-7398-9240-77299e7057d9.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.milb.com/reno/team/club-information",
      "poi_directions_map_url": "https://maps.google.com/?cid=17908350541996976682&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "greater-nevada-field",
      "poi_latitude": "39.5288493",
      "poi_longitude": "-119.8077378",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 775-334-4700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166657/019d02cf-9393-73de-a2c2-f494b767dbf7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cf-9393-73de-a2c2-f494b767dbf7",
        "storage_key": "property/6767906449166657/019d02cf-9393-73de-a2c2-f494b767dbf7.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ10In10pHmYARKmrneO89h_g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_5bcb4f2d-85f1-43bb-b565-48d44b7284c5",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166657",
      "source": "custom",
      "poi_name": "Nevada Museum of Art",
      "poi_type": "Entertainment",
      "poi_address": "160 W Liberty St, Reno, NV 89501, USA",
      "poi_short_description": "Art museum and community space with pieces by regional artists, plus a rooftop terrace, often hosting events.",
      "poi_long_description": "People say this art museum offers stunning art exhibits, a massive toy dinosaur collection, and ichthyosaurus fossils. They highlight the exhibits are beautifully curated, unique, and fascinating, and the docents are knowledgeable and welcoming. They also like the friendly and helpful staff, and the clean and spacious environment.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166657/019d02cf-5f7f-727f-afb9-4bd176f9f026.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cf-5f7f-727f-afb9-4bd176f9f026",
        "storage_key": "property/6767906449166657/019d02cf-5f7f-727f-afb9-4bd176f9f026.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.nevadaart.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12463306709308128641&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "nevada-museum-of-art",
      "poi_latitude": "39.5207823",
      "poi_longitude": "-119.8134183",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 35 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 775-329-3333",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166657/019d02cf-936a-7164-842b-ab745df4700f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cf-936a-7164-842b-ab745df4700f",
        "storage_key": "property/6767906449166657/019d02cf-936a-7164-842b-ab745df4700f.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJwTJN6slAmYARgb0NL2uP9qw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_6d9f3d80-80ef-4560-8f24-a70f08fca750",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166657",
      "source": "custom",
      "poi_name": "Reno Events Center",
      "poi_type": "Entertainment",
      "poi_address": "400 University Wy, Reno, NV 89501, USA",
      "poi_short_description": "Venue for concerts, basketball games and wrestling tournaments (high school and college).",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166657/019d02cf-5f70-7161-a3be-1758ddd51113.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cf-5f70-7161-a3be-1758ddd51113",
        "storage_key": "property/6767906449166657/019d02cf-5f70-7161-a3be-1758ddd51113.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.visitrenotahoe.com/event-venues/reno-events-center",
      "poi_directions_map_url": "https://maps.google.com/?cid=12394465794504265547&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "reno-events-center",
      "poi_latitude": "39.53105559999999",
      "poi_longitude": "-119.8124867",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 775-335-8800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166657/019d02cf-939e-70a0-876a-138860405364.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cf-939e-70a0-876a-138860405364",
        "storage_key": "property/6767906449166657/019d02cf-939e-70a0-876a-138860405364.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJcb_L8DVHmYARSw8orvj8Aaw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "arena"
    },
    {
      "id": "custom_419d23b9-39c0-4ab2-8031-dd89ca3ab254",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166657",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "2863 Northtowne Ln, Reno, NV 89512, USA",
      "poi_short_description": "Chain gym open 24/7 with tanning, massage chairs, and hydromassage facilities.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166657/019d02cf-62c0-739e-a62f-63163993a987.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cf-62c0-739e-a62f-63163993a987",
        "storage_key": "property/6767906449166657/019d02cf-62c0-739e-a62f-63163993a987.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/reno-northtowne-lane-nv?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=6983646585354985188&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "39.5537639",
      "poi_longitude": "-119.786159",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 775-453-9321",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166657/019d02cf-939e-70a0-876a-138860405364.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cf-939e-70a0-876a-138860405364",
        "storage_key": "property/6767906449166657/019d02cf-939e-70a0-876a-138860405364.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJqZ7gep84mYAR5B70hJHl6mA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_d3e39f37-0a46-4d87-8ba9-44ecbacdc545",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166657",
      "source": "custom",
      "poi_name": "Crunch Fitness - Sparks",
      "poi_type": "Health and Wellness",
      "poi_address": "1315 Scheels Drive, Sparks, NV 89434, USA",
      "poi_short_description": "Gym featuring group fitness classes (including zumba and HIIT courses), plus massage chairs and a sauna.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166657/019d02cf-66e4-703c-88bb-66bcdf26fe72.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cf-66e4-703c-88bb-66bcdf26fe72",
        "storage_key": "property/6767906449166657/019d02cf-66e4-703c-88bb-66bcdf26fe72.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.crunch.com/locations/SPARKS",
      "poi_directions_map_url": "https://maps.google.com/?cid=16177985967239562002&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "crunch-fitness---sparks",
      "poi_latitude": "39.5295387",
      "poi_longitude": "-119.7196973",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 9 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 775-420-4276",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166657/019d02cf-939e-70a0-876a-138860405364.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cf-939e-70a0-876a-138860405364",
        "storage_key": "property/6767906449166657/019d02cf-939e-70a0-876a-138860405364.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJkfE7Wtk_mYAREoORxoXAg-A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_13955875-70e5-4089-a7ad-c7242ed8aeca",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166657",
      "source": "custom",
      "poi_name": "BluePearl Pet Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "555 Morrill Ave, Reno, NV 89512, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166657/019d02cf-6b5d-7094-9e3c-ecdc6cab984c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cf-6b5d-7094-9e3c-ecdc6cab984c",
        "storage_key": "property/6767906449166657/019d02cf-6b5d-7094-9e3c-ecdc6cab984c.webp",
        "width": 1024,
        "height": 587
      },
      "poi_business_url": "https://bluepearlvet.com/hospital/reno-nv/?utm_source=maps&utm_medium=google&utm_campaign=gbp",
      "poi_directions_map_url": "https://maps.google.com/?cid=14713825694271974402&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "bluepearl-pet-hospital",
      "poi_latitude": "39.5344576",
      "poi_longitude": "-119.802583",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 775-358-8555",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166657/019d02cf-939e-70a0-876a-138860405364.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cf-939e-70a0-876a-138860405364",
        "storage_key": "property/6767906449166657/019d02cf-939e-70a0-876a-138860405364.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJcwyYLa5AmYARAqwYAoMCMsw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_48c0186e-eb98-409c-963d-a75ce4464bdc",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166657",
      "source": "custom",
      "poi_name": "Fitness Connection",
      "poi_type": "Health and Wellness",
      "poi_address": "255 Disc Dr, Sparks, NV 89436, USA",
      "poi_short_description": "Large gym offering cardio equipment and free weights, plus a sauna.",
      "poi_long_description": "People say this gym offers a pool, sauna, and a wide selection of machines. They also highlight the friendly and helpful staff, and the clean facilities.\n\nOther reviews mention the equipment can be worn.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166657/019d02cf-6c7a-709e-be35-5280333348ac.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cf-6c7a-709e-be35-5280333348ac",
        "storage_key": "property/6767906449166657/019d02cf-6c7a-709e-be35-5280333348ac.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://fitnessconnection.com/gyms/sparks/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7047731678068879414&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "fitness-connection",
      "poi_latitude": "39.5749574",
      "poi_longitude": "-119.7386678",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 44 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 775-359-9393",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166657/019d02cf-939e-70a0-876a-138860405364.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cf-939e-70a0-876a-138860405364",
        "storage_key": "property/6767906449166657/019d02cf-939e-70a0-876a-138860405364.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJTWcJwRw5mYARNjCQ556SzmE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_6ea86591-9da8-47f6-997b-efce297031e2",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166657",
      "source": "custom",
      "poi_name": "Ulta Beauty",
      "poi_type": "Health and Wellness",
      "poi_address": "177 Los Altos Pkwy, Sparks, NV 89436, USA",
      "poi_short_description": "Chain retail store stocked with makeup, skincare, body and hair products, plus salon services.",
      "poi_long_description": "Chain with a diverse selection of cosmetics & other beauty products, plus on-site salon services.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166657/019d02cf-65fc-7698-b350-84ece9ac2be4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cf-65fc-7698-b350-84ece9ac2be4",
        "storage_key": "property/6767906449166657/019d02cf-65fc-7698-b350-84ece9ac2be4.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.ulta.com/stores/sparks-nv-203",
      "poi_directions_map_url": "https://maps.google.com/?cid=7656578327175839281&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ulta-beauty",
      "poi_latitude": "39.581184",
      "poi_longitude": "-119.7406754",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 46 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 775-626-5325",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166657/019d02cf-939e-70a0-876a-138860405364.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cf-939e-70a0-876a-138860405364",
        "storage_key": "property/6767906449166657/019d02cf-939e-70a0-876a-138860405364.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJQYg7WQA5mYARMT5FGmyhQWo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hair_salon"
    },
    {
      "id": "custom_9150574a-d900-4a2f-a41a-ac4b310854ca",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166657",
      "source": "custom",
      "poi_name": "Sports West Athletic Club and Spa",
      "poi_type": "Health and Wellness",
      "poi_address": "1575 S Virginia St, Reno, NV 89502, USA",
      "poi_short_description": "Gym with a pool, sauna, and child care, plus offerings such as Pilates, yoga, and hip-hop dance.",
      "poi_long_description": "People say this gym offers a variety of amenities, including a pool, hot tub, sauna, steam rooms, and a Pilates studio, as well as 24-hour access and a wide range of classes. They also highlight the friendly and helpful staff, the clean and well-maintained facilities, and the welcoming and supportive atmosphere.\n\nSome reviews mention the equipment can be outdated.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166657/019d02cf-6ccc-76da-8ae7-5081916acacd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cf-6ccc-76da-8ae7-5081916acacd",
        "storage_key": "property/6767906449166657/019d02cf-6ccc-76da-8ae7-5081916acacd.webp",
        "width": 600,
        "height": 400
      },
      "poi_business_url": "http://www.sportswestreno.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17371562073614215275&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sports-west-athletic-club-and-spa",
      "poi_latitude": "39.5089424",
      "poi_longitude": "-119.8067518",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 47 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 775-348-6666",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166657/019d02cf-939e-70a0-876a-138860405364.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cf-939e-70a0-876a-138860405364",
        "storage_key": "property/6767906449166657/019d02cf-939e-70a0-876a-138860405364.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJGSEGQJZAmYARa2hs36ovFPE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_4d8c7e9c-d133-4dfa-9a3e-febae1b9acb5",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166657",
      "source": "custom",
      "poi_name": "Renown Regional Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "1155 Mill St, Reno, NV 89502, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166657/019d02cf-6e58-73c7-b6d2-66ee2f7e1c95.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cf-6e58-73c7-b6d2-66ee2f7e1c95",
        "storage_key": "property/6767906449166657/019d02cf-6e58-73c7-b6d2-66ee2f7e1c95.webp",
        "width": 1024,
        "height": 575
      },
      "poi_business_url": "https://www.renown.org/locations/renown-regional-medical-center/?utm_source=GMBlisting&utm_medium=organic&utm_campaign=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=11697565607693477331&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "renown-regional-medical-center",
      "poi_latitude": "39.5262267",
      "poi_longitude": "-119.7952996",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 775-982-4100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166657/019d02cf-939f-70b7-9240-1ed3e4fc22f9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cf-939f-70b7-9240-1ed3e4fc22f9",
        "storage_key": "property/6767906449166657/019d02cf-939f-70b7-9240-1ed3e4fc22f9.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJoZyMTKlAmYAR02Vln_EZVqI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_66a3a67e-3ce0-45a1-8a70-ac344105e5c3",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166657",
      "source": "custom",
      "poi_name": "Northern Nevada Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "2375 E Prater Way, Sparks, NV 89434, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166657/019d02cf-7209-7799-a932-b43fbf0fa3b9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cf-7209-7799-a932-b43fbf0fa3b9",
        "storage_key": "property/6767906449166657/019d02cf-7209-7799-a932-b43fbf0fa3b9.webp",
        "width": 935,
        "height": 526
      },
      "poi_business_url": "https://www.nnmc.com/?utm_source=Google-Business-Yext&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=1383825831704848428&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "northern-nevada-medical-center",
      "poi_latitude": "39.5410413",
      "poi_longitude": "-119.6972916",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 24 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 775-331-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166657/019d02cf-939f-70b7-9240-1ed3e4fc22f9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cf-939f-70b7-9240-1ed3e4fc22f9",
        "storage_key": "property/6767906449166657/019d02cf-939f-70b7-9240-1ed3e4fc22f9.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJhVhqFqA-mYARLOjGGUNWNBM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_33f62c7a-ff6d-4bf5-8ce1-e991fd7deb56",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166657",
      "source": "custom",
      "poi_name": "Idlewild Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2055 Idlewild Dr, Reno, NV 89509, USA",
      "poi_short_description": "Sprawling park offering ponds and walking paths, plus a train for kids.",
      "poi_long_description": "People say this park offers baseball fields, a playground, a pool, a skate park, a rose garden, and access to a river with a river walk. They highlight the beautiful natural scenery, including trees, ducks, geese, and a pond, and the shady spaces for enjoying music and food. They also like the various events, such as the farmers market, Food Truck Friday, and live music performances.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166657/019d02cf-7362-76a1-952e-b8f465dc867d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cf-7362-76a1-952e-b8f465dc867d",
        "storage_key": "property/6767906449166657/019d02cf-7362-76a1-952e-b8f465dc867d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.reno.gov/Home/Components/FacilityDirectory/FacilityDirectory/123/2864?cftype=FacilityDirectory",
      "poi_directions_map_url": "https://maps.google.com/?cid=8214638010290378340&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "idlewild-park",
      "poi_latitude": "39.5218409",
      "poi_longitude": "-119.8329796",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 54 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 775-334-2270",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166657/019d02cf-98c0-71ed-99e7-7bdc3254afe4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cf-98c0-71ed-99e7-7bdc3254afe4",
        "storage_key": "property/6767906449166657/019d02cf-98c0-71ed-99e7-7bdc3254afe4.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJz6-ILStHmYARZJbHUb9BAHI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_2b7ce94b-b23c-4877-820a-711930c979ec",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166657",
      "source": "custom",
      "poi_name": "Rancho San Rafael Regional Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1595 N Sierra St, Reno, NV 89503, USA",
      "poi_short_description": "Sprawling park featuring a play area, museums and trails.",
      "poi_long_description": "Visitors say this park offers a beautiful arboretum with a variety of plants and trees, walking trails, playgrounds, a dog park, and a pond. They also highlight the many events held at the park, including the Great Reno Balloon Race and Dragon Lights.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166657/019d02cf-7397-71a7-a314-3d65dd62a153.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cf-7397-71a7-a314-3d65dd62a153",
        "storage_key": "property/6767906449166657/019d02cf-7397-71a7-a314-3d65dd62a153.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.washoecounty.gov/parks/parks/park_directory_pages/north_region/rancho_san_rafael_regional_park.php",
      "poi_directions_map_url": "https://maps.google.com/?cid=9725301228774930042&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "rancho-san-rafael-regional-park",
      "poi_latitude": "39.5456988",
      "poi_longitude": "-119.8239912",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 11 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 775-785-4512",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166657/019d02cf-98c0-71ed-99e7-7bdc3254afe4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cf-98c0-71ed-99e7-7bdc3254afe4",
        "storage_key": "property/6767906449166657/019d02cf-98c0-71ed-99e7-7bdc3254afe4.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJOdICOBtHmYARerbM0vA194Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_b4dcd2b6-9cab-4047-a927-6491a5a5b7d7",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166657",
      "source": "custom",
      "poi_name": "Washoe County Golf Course",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2601 Foley Way, Reno, NV 89509, USA",
      "poi_short_description": "Challenging course with tree-lined fairways and greens, plus a pro shop, golf carts and a driving range.",
      "poi_long_description": "Golf course featuring 18-holes & practice facilities, plus a pro shop & a restaurant.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166657/019d02cf-75c0-709e-8897-076fe3e0294a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cf-75c0-709e-8897-076fe3e0294a",
        "storage_key": "property/6767906449166657/019d02cf-75c0-709e-8897-076fe3e0294a.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://www.washoegolf.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6753074600951186852&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "washoe-county-golf-course",
      "poi_latitude": "39.49784080000001",
      "poi_longitude": "-119.8210678",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 19 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 775-828-6633",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166657/019d02cf-99ba-709b-9bd6-f0b7140d274f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cf-99ba-709b-9bd6-f0b7140d274f",
        "storage_key": "property/6767906449166657/019d02cf-99ba-709b-9bd6-f0b7140d274f.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJaSAKBfJAmYARpIVo-5G9t10",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_46ab6d15-9bb1-4b9f-81b2-61c8a5d794d1",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166657",
      "source": "custom",
      "poi_name": "Sparks Marina Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "300 Howard Dr, Sparks, NV 89434, USA",
      "poi_short_description": "Lake with sandy beaches, playgrounds, volleyball courts, dog parks and picnic tables.",
      "poi_long_description": "People say this park offers a beautiful beach lake, fishing pier, and walking/running trails. They highlight the easy access to water, good parking, and clean restrooms. They also like the pet-friendly environment and the presence of playgrounds and a Veterans Memorial. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166657/019d02cf-7996-71be-8859-d8418efe9d1e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cf-7996-71be-8859-d8418efe9d1e",
        "storage_key": "property/6767906449166657/019d02cf-7996-71be-8859-d8418efe9d1e.webp",
        "width": 900,
        "height": 601
      },
      "poi_business_url": "https://www.cityofsparks.us/business_detail_T71_R47.php",
      "poi_directions_map_url": "https://maps.google.com/?cid=10786933767510077792&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sparks-marina-park",
      "poi_latitude": "39.5349222",
      "poi_longitude": "-119.7315162",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 48 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 775-353-2376",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166657/019d02cf-98c0-71ed-99e7-7bdc3254afe4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cf-98c0-71ed-99e7-7bdc3254afe4",
        "storage_key": "property/6767906449166657/019d02cf-98c0-71ed-99e7-7bdc3254afe4.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJLVp878I-mYARYLEaJBzjspU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_ce29c6b8-c79c-46f2-8f6c-54ec6a5fddd7",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166657",
      "source": "custom",
      "poi_name": "Mira Loma Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3000 S McCarran Blvd, Reno, NV 89502, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166657/019d02cf-7b72-76ca-bd0b-63e8416ed9e2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cf-7b72-76ca-bd0b-63e8416ed9e2",
        "storage_key": "property/6767906449166657/019d02cf-7b72-76ca-bd0b-63e8416ed9e2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.reno.gov/Home/Components/FacilityDirectory/FacilityDirectory/120/2864?npage=3",
      "poi_directions_map_url": "https://maps.google.com/?cid=15397859341346813640&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mira-loma-park",
      "poi_latitude": "39.4862158",
      "poi_longitude": "-119.7466506",
      "poi_miles_from_property": "8",
      "poi_walking_minutes": "2 hours 55 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 775-689-2968",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166657/019d02cf-98c0-71ed-99e7-7bdc3254afe4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cf-98c0-71ed-99e7-7bdc3254afe4",
        "storage_key": "property/6767906449166657/019d02cf-98c0-71ed-99e7-7bdc3254afe4.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJKRsidso_mYARyDZoVn0vsNU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_ef6a6b3b-c22f-4a40-a438-4694e77f5ddd",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166657",
      "source": "custom",
      "poi_name": "Reno-Tahoe International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "2001 E Plumb Ln, Reno, NV 89502, USA",
      "poi_short_description": "This arts-focused airport features a gallery & occasional live music performances, plus 2 dog parks.",
      "poi_long_description": "People say this airport is small, clean, and easy to navigate. They also highlight the friendly and helpful staff, quick service, and convenient access to parking and car rentals.\n\nOther reviews mention the slot machines can be noisy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166657/019d02cf-7be7-7718-9015-ad4da0a26ed2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cf-7be7-7718-9015-ad4da0a26ed2",
        "storage_key": "property/6767906449166657/019d02cf-7be7-7718-9015-ad4da0a26ed2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.renoairport.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1170969984230185280&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "reno-tahoe-international-airport",
      "poi_latitude": "39.5053099",
      "poi_longitude": "-119.7710533",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 9 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 775-328-6400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166657/019d02cf-99bb-754e-b0fb-645f59014dcb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cf-99bb-754e-b0fb-645f59014dcb",
        "storage_key": "property/6767906449166657/019d02cf-99bb-754e-b0fb-645f59014dcb.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJF0m8rXA_mYARQFmvIP8eQBA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "custom_d89c33d1-ea90-4cb0-9335-a05a5e5a2037",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166657",
      "source": "custom",
      "poi_name": "Sparks City Hall (City of Sparks)",
      "poi_type": "Major Employers & Offices",
      "poi_address": "431 Prater Way, Sparks, NV 89431, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166657/019d02cf-7e4c-727d-bca5-5a27e4801070.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cf-7e4c-727d-bca5-5a27e4801070",
        "storage_key": "property/6767906449166657/019d02cf-7e4c-727d-bca5-5a27e4801070.webp",
        "width": 576,
        "height": 1280
      },
      "poi_business_url": "http://cityofsparks.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16760993102297089656&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sparks-city-hall-city-of-sparks",
      "poi_latitude": "39.5402896",
      "poi_longitude": "-119.7490904",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 775-353-5555",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166657/019d02cf-9a02-72d3-9d2e-21a6038d4730.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cf-9a02-72d3-9d2e-21a6038d4730",
        "storage_key": "property/6767906449166657/019d02cf-9a02-72d3-9d2e-21a6038d4730.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJX79UBCw_mYAReMYwSWwCm-g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "custom_6175e730-5cf2-420c-9db0-83f18a07a3f1",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166657",
      "source": "custom",
      "poi_name": "Newtron",
      "poi_type": "Major Employers & Offices",
      "poi_address": "742 Spice Islands Dr, Sparks, NV 89431, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166657/019d02cf-81a3-7159-8b98-00b0ba3c4af7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cf-81a3-7159-8b98-00b0ba3c4af7",
        "storage_key": "property/6767906449166657/019d02cf-81a3-7159-8b98-00b0ba3c4af7.webp",
        "width": 1280,
        "height": 815
      },
      "poi_business_url": "https://thenewtrongroup.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4878968250925158280&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "newtron",
      "poi_latitude": "39.5138549",
      "poi_longitude": "-119.7305755",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 25 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 775-501-9803",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166657/019d02cf-939e-70a0-876a-138860405364.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cf-939e-70a0-876a-138860405364",
        "storage_key": "property/6767906449166657/019d02cf-939e-70a0-876a-138860405364.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJaf19-7k_mYARiI_NOsaTtUM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_8146ea43-3bdd-48c5-ab12-35ac5e13fdef",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166657",
      "source": "custom",
      "poi_name": "Peppermill Human Resources",
      "poi_type": "Major Employers & Offices",
      "poi_address": "380 Brinkby Ave, Reno, NV 89509, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166657/019d02cf-822f-7529-a920-fdfabc4b8235.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cf-822f-7529-a920-fdfabc4b8235",
        "storage_key": "property/6767906449166657/019d02cf-822f-7529-a920-fdfabc4b8235.webp",
        "width": 592,
        "height": 1280
      },
      "poi_business_url": "http://www.peppermillreno.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6608732781463520004&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "peppermill-human-resources",
      "poi_latitude": "39.4947468",
      "poi_longitude": "-119.80211",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 5 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 775-689-7390",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166657/019d02cf-939e-70a0-876a-138860405364.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cf-939e-70a0-876a-138860405364",
        "storage_key": "property/6767906449166657/019d02cf-939e-70a0-876a-138860405364.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2dEI84hAmYARBMOcPnPvtls",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_22344d9e-e3c4-4d3f-80e9-53a59c645fff",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166657",
      "source": "custom",
      "poi_name": "Scorpions Baseball",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1580 Hymer Ave #110, Sparks, NV 89431, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166657/019d02cf-8211-711c-bfa1-fec0027e90e2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cf-8211-711c-bfa1-fec0027e90e2",
        "storage_key": "property/6767906449166657/019d02cf-8211-711c-bfa1-fec0027e90e2.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://scorpionsbaseballacademy.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7215351985944429820&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "scorpions-baseball",
      "poi_latitude": "39.530962",
      "poi_longitude": "-119.764047",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 775-287-0020",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166657/019d02cf-939e-70a0-876a-138860405364.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cf-939e-70a0-876a-138860405364",
        "storage_key": "property/6767906449166657/019d02cf-939e-70a0-876a-138860405364.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJA_kJTbI_mYAR_ISgE2cUImQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_f003d6c4-3048-4a36-8b8a-9726067ad18b",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166657",
      "source": "custom",
      "poi_name": "Clear Capital",
      "poi_type": "Major Employers & Offices",
      "poi_address": "300 E 2nd St UNIT 1405, Reno, NV 89501, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166657/019d02cf-8570-7549-804d-5087b531c4e9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cf-8570-7549-804d-5087b531c4e9",
        "storage_key": "property/6767906449166657/019d02cf-8570-7549-804d-5087b531c4e9.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://www.clearcapital.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18152032752068128165&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "clear-capital",
      "poi_latitude": "39.5272918",
      "poi_longitude": "-119.8088958",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 21 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 530-550-2500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166657/019d02cf-939e-70a0-876a-138860405364.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cf-939e-70a0-876a-138860405364",
        "storage_key": "property/6767906449166657/019d02cf-939e-70a0-876a-138860405364.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJawru2bRAmYARpe1GSp356Ps",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    }
  ],
  "office_hours": [
    {
      "id": "custom_194d1aa3-9fef-452e-a13a-bf5f7f98acf9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166657",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_279ea99d-d865-4aa6-b012-075a2b5a929b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166657",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_f2b311a5-045d-453a-a3fd-f3add9fb1f25",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166657",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_ad69d925-e222-4006-a698-88ba95554805",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166657",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_72814428-ff33-409b-be04-cab41ff223fe",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166657",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_e0a0f1e5-bff9-407b-9018-7b3ac36c7d99",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166657",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_927d9afde8fa91f4a579690c",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166657",
      "rating": "5",
      "name": "Kevin (Krazekilla925)",
      "text": "I’ve lived here for 3 years now. The office staff is always nice and very professional. They also have a sweet coffee/ espresso machine, which makes it so I’m not going to star bucks daily. The maintenance crew is always on top of stuff when I need something fixed too. This is by far the best apartments I’ve lived in while in Reno.",
      "date": "2025-04-10",
      "title": "false"
    }
  ],
  "virtual_tours": [],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019a2c08-11f6-751c-b455-a56ba996dc69",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "amc-reno-vista-apartments",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166657"
    },
    {
      "lead_collector_id": "019a2c08-5d62-71ee-8f4e-646b1170fd8b",
      "lead_source": "LANDING_PAGE",
      "name": "amc-reno-vista-apartments-lp",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166657"
    },
    {
      "lead_collector_id": "019d6354-be10-77e7-9eaa-0a092d7ff234",
      "lead_source": "FACEBOOK_ADS",
      "name": "Facebook Ads",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166657"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166657",
      "source": "generator",
      "page_item_url": "in-unit-laundry-apartments-reno-nv",
      "search_query": "apartments with in-unit laundry Reno NV",
      "category": "Amenity",
      "h1_title": "Apartments with In-Unit Laundry in Reno, NV",
      "h2_subtitle": "Discover comfortable living with apartments with in-unit laundry in Reno NV. Enjoy the modern convenience at Reno Vista Apartments.",
      "page_copy": "Experience the ultimate convenience of having in-unit laundry at Reno Vista Apartments, located amidst the charm of Northeast Reno. Our thoughtfully designed one and two-bedroom layouts provide everything you need, from spacious interiors to modern amenities such as high-speed internet and stainless steel appliances. Enjoy views of the city from your balcony and the practicality of an island kitchen in your new home.\n\nNestled in Washoe County, Reno Vista Apartments aim to make your everyday life easier with features like in-unit laundry. Relax in our leafy courtyard, let your kids have fun at the playground, or take your furry friend to the pet play area. Benefit from 24-hour maintenance services, ensuring that your comfort is always our priority. Our community offers accessibility-friendly options, making it suitable for everyone seeking a modern living experience in Reno, NV.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166657/019d02cf-1eb7-767a-aaf3-f7d4f57809ed.webp",
      "featured_image_media": {
        "alt_text": "Apartment buildings with fall foliage and a distant cityscape.",
        "public_id": "019d02cf-1eb7-767a-aaf3-f7d4f57809ed",
        "storage_key": "property/6767906449166657/019d02cf-1eb7-767a-aaf3-f7d4f57809ed.webp",
        "width": 1920,
        "height": 1080
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with In-Unit Laundry in Reno, NV",
      "seo_description": "Find Reno NV apartments with in-unit laundry and enjoy modern living. Explore Reno Vista Apartments and their top amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166657",
      "source": "generator",
      "page_item_url": "family-friendly-playground-apartments-washoe-county",
      "search_query": "family-friendly apartments with playground in Washoe County",
      "category": "Amenity",
      "h1_title": "Family-Friendly Apartments with Playground",
      "h2_subtitle": "Explore family-friendly apartments with a playground in Washoe County. Reno Vista Apartments offers ideal homes for families in a vibrant community.",
      "page_copy": "Reno Vista Apartments in Washoe County delivers the perfect balance of comfort and family-friendly amenities. Our spacious one and two-bedroom apartments are tailored to meet all your family's needs, complete with modern amenities and accessible features. Families will love the convenience of a dedicated playground, ensuring your kids have a safe, fun environment right at their doorstep.\n\nLocated in the heart of Northeast Reno, Reno Vista Apartments features lush green spaces where families can unwind together. Alongside our community playground, enjoy the perks of high-speed internet, island kitchens, and stainless steel appliances in each home. Your family will also appreciate being part of a welcoming community while enjoying amenities like a pet play area and wheelchair-accessible rooms. Discover a perfect blend of family-friendly living within this vibrant Washoe County neighborhood.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166657/019d02cf-1eb7-767a-aaf3-f7d4f57809ed.webp",
      "featured_image_media": {
        "alt_text": "Apartment buildings with fall foliage and a distant cityscape.",
        "public_id": "019d02cf-1eb7-767a-aaf3-f7d4f57809ed",
        "storage_key": "property/6767906449166657/019d02cf-1eb7-767a-aaf3-f7d4f57809ed.webp",
        "width": 1920,
        "height": 1080
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Family-Friendly Apartments with Playground",
      "seo_description": "Find family-friendly Washoe County apartments with a playground. Discover Reno Vista Apartments and their perfect amenities for families.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166657",
      "source": "generator",
      "page_item_url": "pet-friendly-dog-park-apartments-northeast-reno",
      "search_query": "pet-friendly apartments with dog park in Northeast Reno",
      "category": "Amenity",
      "h1_title": "Pet-Friendly Apartments with Dog Park",
      "h2_subtitle": "Explore pet-friendly apartments with a dog park in Northeast Reno. Reno Vista Apartments offers the perfect home for you and your furry friends.",
      "page_copy": "At Reno Vista Apartments, located in Northeast Reno, both you and your pets will feel right at home. As a premier pet-friendly community, we offer a dedicated dog park where your furry companions can play and socialize freely. Our one and two-bedroom apartments come with modern amenities like stainless steel appliances and island kitchens, ensuring a comfortable lifestyle for you and your pets.\n\nNestled in Washoe County, Reno Vista Apartments is designed with pet owners in mind, featuring ample green spaces and a convenient pet play area. With high-speed internet and 24-hour maintenance, comfort and ease are always at the forefront. Enjoy beautiful views from your balcony and accessibility features throughout, making it the perfect living choice for pet lovers seeking a vibrant lifestyle in Northeast Reno.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166657/019d02cf-1eb7-767a-aaf3-f7d4f57809ed.webp",
      "featured_image_media": {
        "alt_text": "Apartment buildings with fall foliage and a distant cityscape.",
        "public_id": "019d02cf-1eb7-767a-aaf3-f7d4f57809ed",
        "storage_key": "property/6767906449166657/019d02cf-1eb7-767a-aaf3-f7d4f57809ed.webp",
        "width": 1920,
        "height": 1080
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet-Friendly Apartments with Dog Park",
      "seo_description": "Discover pet-friendly Northeast Reno apartments with a dog park. Reno Vista Apartments offers ideal amenities for pet lovers.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166657",
      "source": "generator",
      "page_item_url": "stainless-steel-appliances-apartments-reno-89512",
      "search_query": "apartments with stainless steel appliances Reno 89512",
      "category": "Amenity",
      "h1_title": "Apartments with Stainless Steel Appliances",
      "h2_subtitle": "Find apartments with stainless steel appliances in Reno 89512. Reno Vista Apartments offers modern living with top-notch kitchen features.",
      "page_copy": "Reno Vista Apartments, situated in the vibrant area of Reno 89512, offers modern living enhanced by stainless steel appliances in every unit. Whether you choose our one or two-bedroom apartments, each home features sleek and stylish kitchens equipped with the latest stainless steel equipment, complementing the island kitchens perfectly.\n\nOur community in Northeast Reno ensures contemporary comfort with additional amenities, such as high-speed internet and beautiful views from private balconies. Residents at Reno Vista can also enjoy the lush courtyard, children's playground, and pet-friendly areas, making it an ideal choice for everyone seeking modern conveniences in Washoe County. With accessible layouts and dedicated maintenance, our focus is on providing a hassle-free and stylish living experience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166657/019d02cf-1eb7-767a-aaf3-f7d4f57809ed.webp",
      "featured_image_media": {
        "alt_text": "Apartment buildings with fall foliage and a distant cityscape.",
        "public_id": "019d02cf-1eb7-767a-aaf3-f7d4f57809ed",
        "storage_key": "property/6767906449166657/019d02cf-1eb7-767a-aaf3-f7d4f57809ed.webp",
        "width": 1920,
        "height": 1080
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Stainless Steel Appliances",
      "seo_description": "Explore Reno 89512 apartments featuring stainless steel appliances at Reno Vista. Enjoy modern kitchens and more in a thriving community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166657",
      "source": "generator",
      "page_item_url": "balcony-air-conditioning-apartments-reno-nv",
      "search_query": "Balcony apartments with air conditioning Reno NV",
      "category": "Amenity",
      "h1_title": "Balcony Apartments with Air Conditioning",
      "h2_subtitle": "Discover balcony apartments with air conditioning in Reno, NV. Reno Vista Apartments offers comfort and style in a sought-after location.",
      "page_copy": "Embrace modern living at Reno Vista Apartments in Reno, NV, where balcony apartments with air conditioning provide the ultimate in comfort and relaxation. Each spacious unit features a private balcony, allowing you to enjoy stunning views while benefiting from the cool breeze of efficient air conditioning, essential for Nevada's warm climate.\n\nSituated in the heart of Northeast Reno, our community offers a perfect blend of style and convenience. Apart from the comfort of air-conditioned interiors, residents can enjoy a range of amenities, including island kitchens, stainless steel appliances, and pet-friendly spaces. Our commitment to quality living ensures a vibrant and welcoming environment, complete with lush green courtyards and a family-friendly playground. Discover contemporary living tailored for today's needs in our convenient Reno location.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166657/019d02cf-1eb7-767a-aaf3-f7d4f57809ed.webp",
      "featured_image_media": {
        "alt_text": "Apartment buildings with fall foliage and a distant cityscape.",
        "public_id": "019d02cf-1eb7-767a-aaf3-f7d4f57809ed",
        "storage_key": "property/6767906449166657/019d02cf-1eb7-767a-aaf3-f7d4f57809ed.webp",
        "width": 1920,
        "height": 1080
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Balcony Apartments with Air Conditioning",
      "seo_description": "Find Reno, NV apartments featuring balconies and air conditioning. Reno Vista Apartments offers comfort with modern amenities and scenic views.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166657",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-reno-nv",
      "search_query": "two bedroom apartments reno nv",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Reno, NV",
      "h2_subtitle": "Explore two bedroom apartments in Reno, NV at Reno Vista Apartments. Enjoy spacious living with modern amenities in a prime location.",
      "page_copy": "Welcome to Reno Vista Apartments, where our two-bedroom apartments in Reno, NV offer the perfect blend of space and style. Each unit is thoughtfully designed with modern layouts and amenities, including stainless steel appliances and island kitchens, making it an ideal choice for comfortable living.\n\nLocated in the picturesque Northeast Reno area, our community provides extensive benefits, such as high-speed internet, wheelchair accessibility, and enticing views from private balconies. With added features like a lush courtyard, playground, and pet-friendly areas, Reno Vista caters to those seeking a welcoming and complete living environment. Discover what makes our two-bedroom apartments a fabulous option for residents in Reno, NV.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166657/019d02cf-1eb7-767a-aaf3-f7d4f57809ed.webp",
      "featured_image_media": {
        "alt_text": "Apartment buildings with fall foliage and a distant cityscape.",
        "public_id": "019d02cf-1eb7-767a-aaf3-f7d4f57809ed",
        "storage_key": "property/6767906449166657/019d02cf-1eb7-767a-aaf3-f7d4f57809ed.webp",
        "width": 1920,
        "height": 1080
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments in Reno, NV",
      "seo_description": "Find spacious two bedroom apartments in Reno, NV at Reno Vista. Enjoy modern living with great amenities in a premier location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166657",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-northeast-reno",
      "search_query": "one bedroom apartments northeast reno",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Northeast Reno",
      "h2_subtitle": "Discover charming one bedroom apartments in Northeast Reno at Reno Vista. Experience the blend of comfort with modern amenities in a premier community.",
      "page_copy": "Reno Vista Apartments offers beautifully designed one-bedroom apartments in Northeast Reno, perfect for those seeking comfort with a touch of elegance. Each apartment is equipped with modern features such as stainless steel appliances and island kitchens, ensuring a contemporary lifestyle.\n\nNestled in the engaging community of Northeast Reno, our property provides a warm environment that includes high-speed internet, private balconies with breathtaking views, and a range of amenities like a pet-friendly play area and lush courtyards. With a focus on quality and convenience, Reno Vista Apartments creates a welcoming ambiance for its residents, making it a top choice for one-bedroom living in the area.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166657/019d02cf-1eb7-767a-aaf3-f7d4f57809ed.webp",
      "featured_image_media": {
        "alt_text": "Apartment buildings with fall foliage and a distant cityscape.",
        "public_id": "019d02cf-1eb7-767a-aaf3-f7d4f57809ed",
        "storage_key": "property/6767906449166657/019d02cf-1eb7-767a-aaf3-f7d4f57809ed.webp",
        "width": 1920,
        "height": 1080
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Northeast Reno",
      "seo_description": "Explore cozy one bedroom apartments in Northeast Reno at Reno Vista. Enjoy modern features and comfortable living in a vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166657",
      "source": "generator",
      "page_item_url": "apartments-near-university-of-nevada-reno",
      "search_query": "apartments near university of nevada reno",
      "category": "School",
      "h1_title": "Apartments Near University of Nevada, Reno",
      "h2_subtitle": "Find modern apartments near the University of Nevada, Reno. Reno Vista offers an ideal location with top amenities for student and faculty living.",
      "page_copy": "Discover the ultimate blend of convenience and comfort at Reno Vista Apartments, situated close to the University of Nevada, Reno. Our community provides an exceptional living experience with proximity to campus facilities, making it perfect for students and faculty alike.\n\nReno Vista features a range of modern amenities, including spacious layouts with stainless steel appliances, island kitchens, and private balconies. Enjoy the peace of mind that comes with 24-hour maintenance and high-speed internet, enhancing your academic and personal life. The vibrant Northeast Reno community offers a lush courtyard, pet-friendly areas, and a family-friendly playground, ensuring a welcoming environment just minutes from campus.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166657/019d02cf-1eb7-767a-aaf3-f7d4f57809ed.webp",
      "featured_image_media": {
        "alt_text": "Apartment buildings with fall foliage and a distant cityscape.",
        "public_id": "019d02cf-1eb7-767a-aaf3-f7d4f57809ed",
        "storage_key": "property/6767906449166657/019d02cf-1eb7-767a-aaf3-f7d4f57809ed.webp",
        "width": 1920,
        "height": 1080
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near University of Nevada, Reno",
      "seo_description": "Explore Reno Vista Apartments near the University of Nevada. Enjoy modern living with premier amenities close to campus.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166657",
      "source": "generator",
      "page_item_url": "apartments-close-to-truckee-meadows-community-college-northeast-reno",
      "search_query": "apartments close to truckee meadows community college northeast reno",
      "category": "School",
      "h1_title": "Apartments Near Truckee Meadows Community College",
      "h2_subtitle": "Explore apartments close to Truckee Meadows Community College in Northeast Reno. Reno Vista offers a prime location with modern amenities for students.",
      "page_copy": "Located just moments away from Truckee Meadows Community College, Reno Vista Apartments in Northeast Reno provides an ideal living option for students and staff seeking convenience and comfort. With easy access to the college, these apartments are the perfect solution for an efficient and enjoyable lifestyle.\n\nOur community offers a variety of modern amenities, including inviting one and two-bedroom layouts featuring stainless steel appliances, high-speed internet, and private balconies. Residents can enjoy the beautiful surroundings with a lush courtyard, a playground for family-friendly activities, and a pet play area. Experience quality living in a vibrant community, making Reno Vista Apartments the perfect home near TMCC.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166657/019d02cf-1eb7-767a-aaf3-f7d4f57809ed.webp",
      "featured_image_media": {
        "alt_text": "Apartment buildings with fall foliage and a distant cityscape.",
        "public_id": "019d02cf-1eb7-767a-aaf3-f7d4f57809ed",
        "storage_key": "property/6767906449166657/019d02cf-1eb7-767a-aaf3-f7d4f57809ed.webp",
        "width": 1920,
        "height": 1080
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Truckee Meadows Community College",
      "seo_description": "Find apartments near Truckee Meadows Community College at Reno Vista. Enjoy modern amenities and close proximity to TMCC in Northeast Reno.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166657",
      "source": "generator",
      "page_item_url": "apartments-near-renown-regional-medical-center-reno",
      "search_query": "apartments near renown regional medical center reno",
      "category": "Hospital",
      "h1_title": "Apartments Near Renown Regional Medical Center",
      "h2_subtitle": "Discover comfortable living in apartments near Renown Regional Medical Center in Reno. Reno Vista offers convenience and modern features.",
      "page_copy": "If you're looking for convenient apartments near Renown Regional Medical Center in Reno, Reno Vista Apartments presents an exceptional option. Our prime location offers easy access to the medical center, making it ideal for healthcare professionals and patients seeking nearby accommodations.\n\nReno Vista not only provides a strategic location but also boasts modern amenities designed to enhance your living experience. Residents can enjoy spacious living with stainless steel appliances, high-speed internet, and private balconies. The community atmosphere is enriched by amenities such as a lush courtyard, a pet-friendly play area, and a playground, ensuring a welcoming environment in Northeast Reno. Explore ideal living just minutes from Renown Regional Medical Center.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166657/019d02cf-1eb7-767a-aaf3-f7d4f57809ed.webp",
      "featured_image_media": {
        "alt_text": "Apartment buildings with fall foliage and a distant cityscape.",
        "public_id": "019d02cf-1eb7-767a-aaf3-f7d4f57809ed",
        "storage_key": "property/6767906449166657/019d02cf-1eb7-767a-aaf3-f7d4f57809ed.webp",
        "width": 1920,
        "height": 1080
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Renown Regional Medical Center",
      "seo_description": "Find ideal living near Renown Regional Medical Center at Reno Vista. Enjoy modern amenities and convenience in Northeast Reno.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166657",
      "source": "generator",
      "page_item_url": "northern-nevada-medical-center-apartments-northeast-reno",
      "search_query": "northern nevada medical center apartments northeast reno",
      "category": "Hospital",
      "h1_title": "Apartments Near Northern Nevada Medical Center",
      "h2_subtitle": "Explore apartments near Northern Nevada Medical Center in Northeast Reno. Reno Vista provides comfort and convenience for medical staff and visitors.",
      "page_copy": "Reno Vista Apartments offers a prime location for those seeking apartments near Northern Nevada Medical Center in Northeast Reno. Whether you are a healthcare professional or visiting a loved one, our community provides the ease and comfort you need being close to medical facilities.\n\nOur apartments feature a variety of modern amenities designed with your lifestyle in mind. Enjoy spacious interiors with stainless steel appliances, island kitchens, and high-speed internet access. Reno Vista also boasts pet-friendly areas, a family playground, and a lush courtyard, contributing to a pleasant living environment. Experience comfortable and convenient living just minutes away from Northern Nevada Medical Center.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166657/019d02cf-1eb7-767a-aaf3-f7d4f57809ed.webp",
      "featured_image_media": {
        "alt_text": "Apartment buildings with fall foliage and a distant cityscape.",
        "public_id": "019d02cf-1eb7-767a-aaf3-f7d4f57809ed",
        "storage_key": "property/6767906449166657/019d02cf-1eb7-767a-aaf3-f7d4f57809ed.webp",
        "width": 1920,
        "height": 1080
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Northern Nevada Medical Center",
      "seo_description": "Discover Reno Vista Apartments near Northern Nevada Medical Center. Enjoy modern amenities and a strategic location in Northeast Reno.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166657",
      "source": "generator",
      "page_item_url": "apartments-near-idlewild-park-reno",
      "search_query": "apartments near idlewild park reno",
      "category": "Park",
      "h1_title": "Apartments Near Idlewild Park, Reno",
      "h2_subtitle": "Discover scenic apartments near Idlewild Park in Reno. Reno Vista offers modern amenities close to nature's beauty and city conveniences.",
      "page_copy": "Embrace the perfect balance of nature and city living at Reno Vista Apartments, conveniently located near Idlewild Park in Reno. Our community offers a prime setting for those who love the serene beauty of the park while enjoying modern urban amenities.\n\nReno Vista Apartments feature spacious one and two-bedroom layouts with contemporary touches such as stainless steel appliances, island kitchens, and balconies offering stunning views. Residents benefit from a pet-friendly environment, a lush courtyard, and a family playground, ideal for leisure and recreation. Experience the charm of living near Idlewild Park while enjoying the conveniences of Northeast Reno.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166657/019d02cf-1eb7-767a-aaf3-f7d4f57809ed.webp",
      "featured_image_media": {
        "alt_text": "Apartment buildings with fall foliage and a distant cityscape.",
        "public_id": "019d02cf-1eb7-767a-aaf3-f7d4f57809ed",
        "storage_key": "property/6767906449166657/019d02cf-1eb7-767a-aaf3-f7d4f57809ed.webp",
        "width": 1920,
        "height": 1080
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Reno Apartments Near Idlewild Park",
      "seo_description": "Live near Idlewild Park at Reno Vista Apartments. Enjoy nature and city life with modern amenities in Northeast Reno.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166657",
      "source": "generator",
      "page_item_url": "reno-vista-apartments-near-rancho-san-rafael-park",
      "search_query": "reno vista apartments close to rancho san rafael regional park",
      "category": "Park",
      "h1_title": "Reno Vista Apartments Near Rancho San Rafael",
      "h2_subtitle": "Experience Reno Vista, close to Rancho San Rafael Regional Park. Enjoy proximity to natural beauty and essential amenities.",
      "page_copy": "Located just a short distance from Rancho San Rafael Regional Park, Reno Vista Apartments offers an enticing blend of convenience and natural surroundings. For those who appreciate nearby outdoor adventures, this location promises easy access to park activities while still being rooted in the vibrant Northeast Reno community.\n\nAt Reno Vista Apartments, residents enjoy a selection of modern amenities that enhance everyday living. Spacious interiors equipped with island kitchens, stainless steel appliances, and balconies elevate comfort. The community features include a lush courtyard, pet and family-friendly amenities, and high-speed internet, ensuring that your home meets all lifestyle needs. Explore the tranquility and excitement of living near Rancho San Rafael Regional Park without compromising on modern conveniences.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166657/019d02cf-1eb7-767a-aaf3-f7d4f57809ed.webp",
      "featured_image_media": {
        "alt_text": "Apartment buildings with fall foliage and a distant cityscape.",
        "public_id": "019d02cf-1eb7-767a-aaf3-f7d4f57809ed",
        "storage_key": "property/6767906449166657/019d02cf-1eb7-767a-aaf3-f7d4f57809ed.webp",
        "width": 1920,
        "height": 1080
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Reno Vista Near Rancho San Rafael Park",
      "seo_description": "Discover Reno Vista Apartments close to Rancho San Rafael Park. Enjoy modern living in Northeast Reno with access to nature and city conveniences.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166657",
      "source": "generator",
      "page_item_url": "apartments-near-sparks-marina-park-reno",
      "search_query": "apartments near sparks marina park in reno",
      "category": "Park",
      "h1_title": "Apartments Near Sparks Marina Park, Reno",
      "h2_subtitle": "Discover Reno Vista, close to Sparks Marina Park. Enjoy lakeside activities and a vibrant community in Reno's Northeast.",
      "page_copy": "Reno Vista Apartments provides an excellent location for those interested in living near Sparks Marina Park. This community is perfect for outdoor enthusiasts who enjoy lakeside walks and water activities, all within reach while living in vibrant Northeast Reno.\n\nAt Reno Vista, each apartment is thoughtfully designed with modern conveniences like island kitchens, stainless steel appliances, and spacious balconies. Our lush green courtyard, family playground, and pet-friendly perks enhance the quality of life for all residents. Choose Reno Vista, a place that balances access to beautiful Sparks Marina Park with the comforts of contemporary living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166657/019d02cf-1eb7-767a-aaf3-f7d4f57809ed.webp",
      "featured_image_media": {
        "alt_text": "Apartment buildings with fall foliage and a distant cityscape.",
        "public_id": "019d02cf-1eb7-767a-aaf3-f7d4f57809ed",
        "storage_key": "property/6767906449166657/019d02cf-1eb7-767a-aaf3-f7d4f57809ed.webp",
        "width": 1920,
        "height": 1080
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Reno Apartments Near Sparks Marina Park",
      "seo_description": "Live at Reno Vista Apartments near Sparks Marina Park. Enjoy convenient urban living in Reno with access to outdoor activities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166657",
      "source": "generator",
      "page_item_url": "living-near-mira-loma-park-washoe-county",
      "search_query": "living near mira loma park in washoe county",
      "category": "Park",
      "h1_title": "Living Near Mira Loma Park",
      "h2_subtitle": "Explore living near Mira Loma Park in Washoe County. Reno Vista offers modern amenities close to parks and city life.",
      "page_copy": "Situated conveniently in Washoe County, Reno Vista Apartments offers a perfect setting for those looking to live near Mira Loma Park. This thriving community ensures residents can enjoy the tranquility of nearby green spaces while having easy access to the bustling life of Reno.\n\nReno Vista Apartments features spacious layouts with modern amenities including island kitchens and stainless steel appliances. The community boasts a lush courtyard, playground, and pet play area, ensuring every member of your household feels at home. Experience the ease of living close to Mira Loma Park while enjoying all the contemporary comforts and conveniences Reno Vista has to offer.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166657/019d02cf-1eb7-767a-aaf3-f7d4f57809ed.webp",
      "featured_image_media": {
        "alt_text": "Apartment buildings with fall foliage and a distant cityscape.",
        "public_id": "019d02cf-1eb7-767a-aaf3-f7d4f57809ed",
        "storage_key": "property/6767906449166657/019d02cf-1eb7-767a-aaf3-f7d4f57809ed.webp",
        "width": 1920,
        "height": 1080
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Reno Apartments Near Mira Loma Park",
      "seo_description": "Discover the perks of living near Mira Loma Park at Reno Vista Apartments in Washoe County. Enjoy nature and modern living combined.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166657",
      "source": "generator",
      "page_item_url": "apartments-near-reno-tahoe-international-airport",
      "search_query": "apartments near reno-tahoe international airport",
      "category": "Transit",
      "h1_title": "Apartments Near Reno-Tahoe Airport",
      "h2_subtitle": "Find Reno Vista Apartments near Reno-Tahoe International Airport. Enjoy convenience and comfort in Northeast Reno.",
      "page_copy": "Located just a quick drive from Reno-Tahoe International Airport, Reno Vista Apartments offers unparalleled convenience for frequent travelers and professionals alike. Nestled in Northeast Reno, our community provides easy access to airport amenities while maintaining a serene residential atmosphere.\n\nReno Vista Apartments features thoughtfully designed one and two-bedroom layouts, complete with island kitchens, stainless steel appliances, and spacious balconies. The vibrant community includes amenities such as a family-friendly playground, a pet play area, and lush courtyards, ensuring every need is met. Choose Reno Vista Apartments for a lifestyle that combines ease of travel with the comfort of modern living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166657/019d02cf-1eb7-767a-aaf3-f7d4f57809ed.webp",
      "featured_image_media": {
        "alt_text": "Apartment buildings with fall foliage and a distant cityscape.",
        "public_id": "019d02cf-1eb7-767a-aaf3-f7d4f57809ed",
        "storage_key": "property/6767906449166657/019d02cf-1eb7-767a-aaf3-f7d4f57809ed.webp",
        "width": 1920,
        "height": 1080
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Reno Apartments Near Airport Convenience",
      "seo_description": "Reno Vista offers apartments near Reno-Tahoe Airport. Enjoy easy travel access alongside modern amenities in Northeast Reno.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5592"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "18283064750"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-P9Q4KTC2"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Phase 3"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Preferred"
    },
    {
      "ID": "custom_aim_property_code",
      "type": "STRING",
      "value": "22RNO"
    },
    {
      "ID": "custom_anyonehome_chatbot",
      "type": "STRING",
      "value": "<link rel='stylesheet' href='https://www.myshowing.com/css/omnichannel/omnichannel_communication.css'> <script src='https://www.myshowing.com/js/omnichannel/omnichannel_communication.js'></script><script text='text/javascript'>window.OmniChannel.init('y3WRaRVYa8M6b6Zct1')</script>"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "42190899218"
    },
    {
      "ID": "custom_broker_license_number",
      "type": "STRING",
      "value": "PM.0163249.BKR"
    },
    {
      "ID": "custom_anyonehome_scheduler_url",
      "type": "STRING",
      "value": "https://www.myshowing.com/AMC LLC/Reno Vista/scheduletourwidget/ob1rPk4JtEChWHd3zf/"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6Ik9YVHRka3lqcCswQit4UlpXRlRWV0E9PSIsInZhbHVlIjoiYm9oOE5UUWFoZDAyUzJaaHJYek5XQT09IiwibWFjIjoiZWUxNTY4M2NjYzc1ZTdkZmIxNWViZmRhMWUyNzM4NDQwODljODAyOGUzMDY1ZjFhYzkxZTc1ZDNlMzZiZDRjYiJ9"
    }
  ],
  "custom_qb_id": "5592",
  "custom_repli_id": "18283064750",
  "custom_google_gtm_id": "GTM-P9Q4KTC2",
  "custom_rollout_phase": "Phase 3",
  "custom_vibesites_theme": "Preferred",
  "custom_aim_property_code": "22RNO",
  "custom_anyonehome_chatbot": "<link rel='stylesheet' href='https://www.myshowing.com/css/omnichannel/omnichannel_communication.css'> <script src='https://www.myshowing.com/js/omnichannel/omnichannel_communication.js'></script><script text='text/javascript'>window.OmniChannel.init('y3WRaRVYa8M6b6Zct1')</script>",
  "custom_hubspot_company_id": "42190899218",
  "custom_broker_license_number": "PM.0163249.BKR",
  "custom_anyonehome_scheduler_url": "https://www.myshowing.com/AMC LLC/Reno Vista/scheduletourwidget/ob1rPk4JtEChWHd3zf/",
  "custom_apartmentsync_javascript_id": "eyJpdiI6Ik9YVHRka3lqcCswQit4UlpXRlRWV0E9PSIsInZhbHVlIjoiYm9oOE5UUWFoZDAyUzJaaHJYek5XQT09IiwibWFjIjoiZWUxNTY4M2NjYzc1ZTdkZmIxNWViZmRhMWUyNzM4NDQwODljODAyOGUzMDY1ZjFhYzkxZTc1ZDNlMzZiZDRjYiJ9",
  "custom_audioeye_site_id": "c074f3e2-5c82-4110-a836-7dc2a831ed8f",
  "custom_audioeye_site_hash": "ec7a77078473119f366e35a1ee80c80d"
};

export const generatedAt = '2026-10-05T17:25:37.848Z';
